function z() {
}
const _t = (t) => t;
function Me(t, e) {
  for (const n in e)
    t[n] = e[n];
  return t;
}
function sn(t) {
  return t();
}
function Pt() {
  return /* @__PURE__ */ Object.create(null);
}
function ee(t) {
  t.forEach(sn);
}
function se(t) {
  return typeof t == "function";
}
function ue(t, e) {
  return t != t ? e == e : t !== e || t && typeof t == "object" || typeof t == "function";
}
function qn(t) {
  return Object.keys(t).length === 0;
}
function wt(t, ...e) {
  if (t == null)
    return z;
  const n = t.subscribe(...e);
  return n.unsubscribe ? () => n.unsubscribe() : n;
}
function Kn(t) {
  let e;
  return wt(t, (n) => e = n)(), e;
}
function Ke(t, e, n) {
  t.$$.on_destroy.push(wt(e, n));
}
function Ae(t) {
  return t && se(t.destroy) ? t.destroy : z;
}
const un = typeof window < "u";
let kt = un ? () => window.performance.now() : () => Date.now(), xt = un ? (t) => requestAnimationFrame(t) : z;
const ke = /* @__PURE__ */ new Set();
function cn(t) {
  ke.forEach((e) => {
    e.c(t) || (ke.delete(e), e.f());
  }), ke.size !== 0 && xt(cn);
}
function St(t) {
  let e;
  return ke.size === 0 && xt(cn), {
    promise: new Promise((n) => {
      ke.add(e = { c: t, f: n });
    }),
    abort() {
      ke.delete(e);
    }
  };
}
function T(t, e) {
  t.appendChild(e);
}
function Ce(t, e, n) {
  const r = Ot(t);
  if (!r.getElementById(e)) {
    const o = R("style");
    o.id = e, o.textContent = n, fn(r, o);
  }
}
function Ot(t) {
  if (!t)
    return document;
  const e = t.getRootNode ? t.getRootNode() : t.ownerDocument;
  return e && e.host ? e : t.ownerDocument;
}
function Bn(t) {
  const e = R("style");
  return fn(Ot(t), e), e.sheet;
}
function fn(t, e) {
  return T(t.head || t, e), e.sheet;
}
function J(t, e, n) {
  t.insertBefore(e, n || null);
}
function $(t) {
  t.parentNode && t.parentNode.removeChild(t);
}
function Ve(t, e) {
  for (let n = 0; n < t.length; n += 1)
    t[n] && t[n].d(e);
}
function R(t) {
  return document.createElement(t);
}
function at(t) {
  return document.createElementNS("http://www.w3.org/2000/svg", t);
}
function re(t) {
  return document.createTextNode(t);
}
function Y() {
  return re(" ");
}
function dn() {
  return re("");
}
function le(t, e, n, r) {
  return t.addEventListener(e, n, r), () => t.removeEventListener(e, n, r);
}
function C(t, e, n) {
  n == null ? t.removeAttribute(e) : t.getAttribute(e) !== n && t.setAttribute(e, n);
}
const zn = ["width", "height"];
function _e(t, e) {
  const n = Object.getOwnPropertyDescriptors(t.__proto__);
  for (const r in e)
    e[r] == null ? t.removeAttribute(r) : r === "style" ? t.style.cssText = e[r] : r === "__value" ? t.value = t[r] = e[r] : n[r] && n[r].set && zn.indexOf(r) === -1 ? t[r] = e[r] : C(t, r, e[r]);
}
function Un(t) {
  return Array.from(t.childNodes);
}
function Oe(t, e) {
  e = "" + e, t.data !== e && (t.data = e);
}
function W(t, e, n, r) {
  n == null ? t.style.removeProperty(e) : t.style.setProperty(e, n, "");
}
function jt(t, e, n) {
  for (let r = 0; r < t.options.length; r += 1) {
    const o = t.options[r];
    if (o.__value === e) {
      o.selected = !0;
      return;
    }
  }
  (!n || e !== void 0) && (t.selectedIndex = -1);
}
function Vn(t) {
  const e = t.querySelector(":checked");
  return e && e.__value;
}
function we(t, e, n) {
  t.classList.add(e);
}
function vn(t, e, { bubbles: n = !1, cancelable: r = !1 } = {}) {
  const o = document.createEvent("CustomEvent");
  return o.initCustomEvent(t, n, r, e), o;
}
const $e = /* @__PURE__ */ new Map();
let He = 0;
function Wn(t) {
  let e = 5381, n = t.length;
  for (; n--; )
    e = (e << 5) - e ^ t.charCodeAt(n);
  return e >>> 0;
}
function Gn(t, e) {
  const n = { stylesheet: Bn(e), rules: {} };
  return $e.set(t, n), n;
}
function Xe(t, e, n, r, o, a, i, u = 0) {
  const s = 16.666 / r;
  let l = `{
`;
  for (let w = 0; w <= 1; w += s) {
    const N = e + (n - e) * a(w);
    l += w * 100 + `%{${i(N, 1 - N)}}
`;
  }
  const v = l + `100% {${i(n, 1 - n)}}
}`, c = `__svelte_${Wn(v)}_${u}`, h = Ot(t), { stylesheet: b, rules: x } = $e.get(h) || Gn(h, t);
  x[c] || (x[c] = !0, b.insertRule(`@keyframes ${c} ${v}`, b.cssRules.length));
  const P = t.style.animation || "";
  return t.style.animation = `${P ? `${P}, ` : ""}${c} ${r}ms linear ${o}ms 1 both`, He += 1, c;
}
function Je(t, e) {
  const n = (t.style.animation || "").split(", "), r = n.filter(
    e ? (a) => a.indexOf(e) < 0 : (a) => a.indexOf("__svelte") === -1
    // remove all Svelte animations
  ), o = n.length - r.length;
  o && (t.style.animation = r.join(", "), He -= o, He || Yn());
}
function Yn() {
  xt(() => {
    He || ($e.forEach((t) => {
      const { ownerNode: e } = t.stylesheet;
      e && $(e);
    }), $e.clear());
  });
}
let Re;
function De(t) {
  Re = t;
}
function Ct() {
  if (!Re)
    throw new Error("Function called outside component initialization");
  return Re;
}
function bn(t) {
  Ct().$$.on_mount.push(t);
}
function ot(t) {
  Ct().$$.on_destroy.push(t);
}
function $n() {
  const t = Ct();
  return (e, n, { cancelable: r = !1 } = {}) => {
    const o = t.$$.callbacks[e];
    if (o) {
      const a = vn(e, n, { cancelable: r });
      return o.slice().forEach((i) => {
        i.call(t, a);
      }), !a.defaultPrevented;
    }
    return !0;
  };
}
const ye = [], pt = [];
let xe = [];
const At = [], pn = /* @__PURE__ */ Promise.resolve();
let ht = !1;
function hn() {
  ht || (ht = !0, pn.then(gn));
}
function Hn() {
  return hn(), pn;
}
function ie(t) {
  xe.push(t);
}
const lt = /* @__PURE__ */ new Set();
let ge = 0;
function gn() {
  if (ge !== 0)
    return;
  const t = Re;
  do {
    try {
      for (; ge < ye.length; ) {
        const e = ye[ge];
        ge++, De(e), Xn(e.$$);
      }
    } catch (e) {
      throw ye.length = 0, ge = 0, e;
    }
    for (De(null), ye.length = 0, ge = 0; pt.length; )
      pt.pop()();
    for (let e = 0; e < xe.length; e += 1) {
      const n = xe[e];
      lt.has(n) || (lt.add(n), n());
    }
    xe.length = 0;
  } while (ye.length);
  for (; At.length; )
    At.pop()();
  ht = !1, lt.clear(), De(t);
}
function Xn(t) {
  if (t.fragment !== null) {
    t.update(), ee(t.before_update);
    const e = t.dirty;
    t.dirty = [-1], t.fragment && t.fragment.p(t.ctx, e), t.after_update.forEach(ie);
  }
}
function Jn(t) {
  const e = [], n = [];
  xe.forEach((r) => t.indexOf(r) === -1 ? e.push(r) : n.push(r)), n.forEach((r) => r()), xe = e;
}
let Te;
function Et() {
  return Te || (Te = Promise.resolve(), Te.then(() => {
    Te = null;
  })), Te;
}
function ce(t, e, n) {
  t.dispatchEvent(vn(`${e ? "intro" : "outro"}${n}`));
}
const We = /* @__PURE__ */ new Set();
let oe;
function Ne() {
  oe = {
    r: 0,
    c: [],
    p: oe
    // parent group
  };
}
function Fe() {
  oe.r || ee(oe.c), oe = oe.p;
}
function G(t, e) {
  t && t.i && (We.delete(t), t.i(e));
}
function X(t, e, n, r) {
  if (t && t.o) {
    if (We.has(t))
      return;
    We.add(t), oe.c.push(() => {
      We.delete(t), r && (n && t.d(1), r());
    }), t.o(e);
  } else
    r && r();
}
const Tt = { duration: 0 };
function mn(t, e, n) {
  const r = { direction: "in" };
  let o = e(t, n, r), a = !1, i, u, s = 0;
  function l() {
    i && Je(t, i);
  }
  function v() {
    const { delay: h = 0, duration: b = 300, easing: x = _t, tick: P = z, css: w } = o || Tt;
    w && (i = Xe(t, 0, 1, b, h, x, w, s++)), P(0, 1);
    const N = kt() + h, A = N + b;
    u && u.abort(), a = !0, ie(() => ce(t, !0, "start")), u = St((y) => {
      if (a) {
        if (y >= A)
          return P(1, 0), ce(t, !0, "end"), l(), a = !1;
        if (y >= N) {
          const F = x((y - N) / b);
          P(F, 1 - F);
        }
      }
      return a;
    });
  }
  let c = !1;
  return {
    start() {
      c || (c = !0, Je(t), se(o) ? (o = o(r), Et().then(v)) : v());
    },
    invalidate() {
      c = !1;
    },
    end() {
      a && (l(), a = !1);
    }
  };
}
function yn(t, e, n) {
  const r = { direction: "out" };
  let o = e(t, n, r), a = !0, i;
  const u = oe;
  u.r += 1;
  function s() {
    const { delay: l = 0, duration: v = 300, easing: c = _t, tick: h = z, css: b } = o || Tt;
    b && (i = Xe(t, 1, 0, v, l, c, b));
    const x = kt() + l, P = x + v;
    ie(() => ce(t, !1, "start")), St((w) => {
      if (a) {
        if (w >= P)
          return h(0, 1), ce(t, !1, "end"), --u.r || ee(u.c), !1;
        if (w >= x) {
          const N = c((w - x) / v);
          h(1 - N, N);
        }
      }
      return a;
    });
  }
  return se(o) ? Et().then(() => {
    o = o(r), s();
  }) : s(), {
    end(l) {
      l && o.tick && o.tick(1, 0), a && (i && Je(t, i), a = !1);
    }
  };
}
function Dt(t, e, n, r) {
  const o = { direction: "both" };
  let a = e(t, n, o), i = r ? 0 : 1, u = null, s = null, l = null;
  function v() {
    l && Je(t, l);
  }
  function c(b, x) {
    const P = b.b - i;
    return x *= Math.abs(P), {
      a: i,
      b: b.b,
      d: P,
      duration: x,
      start: b.start,
      end: b.start + x,
      group: b.group
    };
  }
  function h(b) {
    const { delay: x = 0, duration: P = 300, easing: w = _t, tick: N = z, css: A } = a || Tt, y = {
      start: kt() + x,
      b
    };
    b || (y.group = oe, oe.r += 1), u || s ? s = y : (A && (v(), l = Xe(t, i, b, P, x, w, A)), b && N(0, 1), u = c(y, P), ie(() => ce(t, b, "start")), St((F) => {
      if (s && F > s.start && (u = c(s, P), s = null, ce(t, u.b, "start"), A && (v(), l = Xe(t, i, u.b, u.duration, 0, w, a.css))), u) {
        if (F >= u.end)
          N(i = u.b, 1 - i), ce(t, u.b, "end"), s || (u.b ? v() : --u.group.r || ee(u.group.c)), u = null;
        else if (F >= u.start) {
          const Q = F - u.start;
          i = u.a + u.d * w(Q / u.duration), N(i, 1 - i);
        }
      }
      return !!(u || s);
    }));
  }
  return {
    run(b) {
      se(a) ? Et().then(() => {
        a = a(o), h(b);
      }) : h(b);
    },
    end() {
      v(), u = s = null;
    }
  };
}
function gt(t, e) {
  const n = {}, r = {}, o = { $$scope: 1 };
  let a = t.length;
  for (; a--; ) {
    const i = t[a], u = e[a];
    if (u) {
      for (const s in i)
        s in u || (r[s] = 1);
      for (const s in u)
        o[s] || (n[s] = u[s], o[s] = 1);
      t[a] = u;
    } else
      for (const s in i)
        o[s] = 1;
  }
  for (const i in r)
    i in n || (n[i] = void 0);
  return n;
}
function Ee(t) {
  t && t.c();
}
function de(t, e, n, r) {
  const { fragment: o, after_update: a } = t.$$;
  o && o.m(e, n), r || ie(() => {
    const i = t.$$.on_mount.map(sn).filter(se);
    t.$$.on_destroy ? t.$$.on_destroy.push(...i) : ee(i), t.$$.on_mount = [];
  }), a.forEach(ie);
}
function ve(t, e) {
  const n = t.$$;
  n.fragment !== null && (Jn(n.after_update), ee(n.on_destroy), n.fragment && n.fragment.d(e), n.on_destroy = n.fragment = null, n.ctx = []);
}
function Zn(t, e) {
  t.$$.dirty[0] === -1 && (ye.push(t), hn(), t.$$.dirty.fill(0)), t.$$.dirty[e / 31 | 0] |= 1 << e % 31;
}
function be(t, e, n, r, o, a, i, u = [-1]) {
  const s = Re;
  De(t);
  const l = t.$$ = {
    fragment: null,
    ctx: [],
    // state
    props: a,
    update: z,
    not_equal: o,
    bound: Pt(),
    // lifecycle
    on_mount: [],
    on_destroy: [],
    on_disconnect: [],
    before_update: [],
    after_update: [],
    context: new Map(e.context || (s ? s.$$.context : [])),
    // everything else
    callbacks: Pt(),
    dirty: u,
    skip_bound: !1,
    root: e.target || s.$$.root
  };
  i && i(l.root);
  let v = !1;
  if (l.ctx = n ? n(t, e.props || {}, (c, h, ...b) => {
    const x = b.length ? b[0] : h;
    return l.ctx && o(l.ctx[c], l.ctx[c] = x) && (!l.skip_bound && l.bound[c] && l.bound[c](x), v && Zn(t, c)), h;
  }) : [], l.update(), v = !0, ee(l.before_update), l.fragment = r ? r(l.ctx) : !1, e.target) {
    if (e.hydrate) {
      const c = Un(e.target);
      l.fragment && l.fragment.l(c), c.forEach($);
    } else
      l.fragment && l.fragment.c();
    e.intro && G(t.$$.fragment), de(t, e.target, e.anchor, e.customElement), gn();
  }
  De(s);
}
class pe {
  $destroy() {
    ve(this, 1), this.$destroy = z;
  }
  $on(e, n) {
    if (!se(n))
      return z;
    const r = this.$$.callbacks[e] || (this.$$.callbacks[e] = []);
    return r.push(n), () => {
      const o = r.indexOf(n);
      o !== -1 && r.splice(o, 1);
    };
  }
  $set(e) {
    this.$$set && !qn(e) && (this.$$.skip_bound = !0, this.$$set(e), this.$$.skip_bound = !1);
  }
}
function Qn(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var _n = { exports: {} };
(function(t) {
  (function(e, n, r) {
    if (!e)
      return;
    for (var o = {
      8: "backspace",
      9: "tab",
      13: "enter",
      16: "shift",
      17: "ctrl",
      18: "alt",
      20: "capslock",
      27: "esc",
      32: "space",
      33: "pageup",
      34: "pagedown",
      35: "end",
      36: "home",
      37: "left",
      38: "up",
      39: "right",
      40: "down",
      45: "ins",
      46: "del",
      91: "meta",
      93: "meta",
      224: "meta"
    }, a = {
      106: "*",
      107: "+",
      109: "-",
      110: ".",
      111: "/",
      186: ";",
      187: "=",
      188: ",",
      189: "-",
      190: ".",
      191: "/",
      192: "`",
      219: "[",
      220: "\\",
      221: "]",
      222: "'"
    }, i = {
      "~": "`",
      "!": "1",
      "@": "2",
      "#": "3",
      $: "4",
      "%": "5",
      "^": "6",
      "&": "7",
      "*": "8",
      "(": "9",
      ")": "0",
      _: "-",
      "+": "=",
      ":": ";",
      '"': "'",
      "<": ",",
      ">": ".",
      "?": "/",
      "|": "\\"
    }, u = {
      option: "alt",
      command: "meta",
      return: "enter",
      escape: "esc",
      plus: "+",
      mod: /Mac|iPod|iPhone|iPad/.test(navigator.platform) ? "meta" : "ctrl"
    }, s, l = 1; l < 20; ++l)
      o[111 + l] = "f" + l;
    for (l = 0; l <= 9; ++l)
      o[l + 96] = l.toString();
    function v(d, g, S) {
      if (d.addEventListener) {
        d.addEventListener(g, S, !1);
        return;
      }
      d.attachEvent("on" + g, S);
    }
    function c(d) {
      if (d.type == "keypress") {
        var g = String.fromCharCode(d.which);
        return d.shiftKey || (g = g.toLowerCase()), g;
      }
      return o[d.which] ? o[d.which] : a[d.which] ? a[d.which] : String.fromCharCode(d.which).toLowerCase();
    }
    function h(d, g) {
      return d.sort().join(",") === g.sort().join(",");
    }
    function b(d) {
      var g = [];
      return d.shiftKey && g.push("shift"), d.altKey && g.push("alt"), d.ctrlKey && g.push("ctrl"), d.metaKey && g.push("meta"), g;
    }
    function x(d) {
      if (d.preventDefault) {
        d.preventDefault();
        return;
      }
      d.returnValue = !1;
    }
    function P(d) {
      if (d.stopPropagation) {
        d.stopPropagation();
        return;
      }
      d.cancelBubble = !0;
    }
    function w(d) {
      return d == "shift" || d == "ctrl" || d == "alt" || d == "meta";
    }
    function N() {
      if (!s) {
        s = {};
        for (var d in o)
          d > 95 && d < 112 || o.hasOwnProperty(d) && (s[o[d]] = d);
      }
      return s;
    }
    function A(d, g, S) {
      return S || (S = N()[d] ? "keydown" : "keypress"), S == "keypress" && g.length && (S = "keydown"), S;
    }
    function y(d) {
      return d === "+" ? ["+"] : (d = d.replace(/\+{2}/g, "+plus"), d.split("+"));
    }
    function F(d, g) {
      var S, f, p, k = [];
      for (S = y(d), p = 0; p < S.length; ++p)
        f = S[p], u[f] && (f = u[f]), g && g != "keypress" && i[f] && (f = i[f], k.push("shift")), w(f) && k.push(f);
      return g = A(f, k, g), {
        key: f,
        modifiers: k,
        action: g
      };
    }
    function Q(d, g) {
      return d === null || d === n ? !1 : d === g ? !0 : Q(d.parentNode, g);
    }
    function U(d) {
      var g = this;
      if (d = d || n, !(g instanceof U))
        return new U(d);
      g.target = d, g._callbacks = {}, g._directMap = {};
      var S = {}, f, p = !1, k = !1, M = !1;
      function L(j) {
        j = j || {};
        var O = !1, q;
        for (q in S) {
          if (j[q]) {
            O = !0;
            continue;
          }
          S[q] = 0;
        }
        O || (M = !1);
      }
      function B(j, O, q, I, D, ne) {
        var m, E, _ = [], H = q.type;
        if (!g._callbacks[j])
          return [];
        for (H == "keyup" && w(j) && (O = [j]), m = 0; m < g._callbacks[j].length; ++m)
          if (E = g._callbacks[j][m], !(!I && E.seq && S[E.seq] != E.level) && H == E.action && (H == "keypress" && !q.metaKey && !q.ctrlKey || h(O, E.modifiers))) {
            var Rn = !I && E.combo == D, Ln = I && E.seq == I && E.level == ne;
            (Rn || Ln) && g._callbacks[j].splice(m, 1), _.push(E);
          }
        return _;
      }
      function V(j, O, q, I) {
        g.stopCallback(O, O.target || O.srcElement, q, I) || j(O, q) === !1 && (x(O), P(O));
      }
      g._handleKey = function(j, O, q) {
        var I = B(j, O, q), D, ne = {}, m = 0, E = !1;
        for (D = 0; D < I.length; ++D)
          I[D].seq && (m = Math.max(m, I[D].level));
        for (D = 0; D < I.length; ++D) {
          if (I[D].seq) {
            if (I[D].level != m)
              continue;
            E = !0, ne[I[D].seq] = 1, V(I[D].callback, q, I[D].combo, I[D].seq);
            continue;
          }
          E || V(I[D].callback, q, I[D].combo);
        }
        var _ = q.type == "keypress" && k;
        q.type == M && !w(j) && !_ && L(ne), k = E && q.type == "keydown";
      };
      function Z(j) {
        typeof j.which != "number" && (j.which = j.keyCode);
        var O = c(j);
        if (O) {
          if (j.type == "keyup" && p === O) {
            p = !1;
            return;
          }
          g.handleKey(O, b(j), j);
        }
      }
      function te() {
        clearTimeout(f), f = setTimeout(L, 1e3);
      }
      function K(j, O, q, I) {
        S[j] = 0;
        function D(H) {
          return function() {
            M = H, ++S[j], te();
          };
        }
        function ne(H) {
          V(q, H, j), I !== "keyup" && (p = c(H)), setTimeout(L, 10);
        }
        for (var m = 0; m < O.length; ++m) {
          var E = m + 1 === O.length, _ = E ? ne : D(I || F(O[m + 1]).action);
          he(O[m], _, I, j, m);
        }
      }
      function he(j, O, q, I, D) {
        g._directMap[j + ":" + q] = O, j = j.replace(/\s+/g, " ");
        var ne = j.split(" "), m;
        if (ne.length > 1) {
          K(j, ne, O, q);
          return;
        }
        m = F(j, q), g._callbacks[m.key] = g._callbacks[m.key] || [], B(m.key, m.modifiers, { type: m.action }, I, j, D), g._callbacks[m.key][I ? "unshift" : "push"]({
          callback: O,
          modifiers: m.modifiers,
          action: m.action,
          seq: I,
          level: D,
          combo: j
        });
      }
      g._bindMultiple = function(j, O, q) {
        for (var I = 0; I < j.length; ++I)
          he(j[I], O, q);
      }, v(d, "keypress", Z), v(d, "keydown", Z), v(d, "keyup", Z);
    }
    U.prototype.bind = function(d, g, S) {
      var f = this;
      return d = d instanceof Array ? d : [d], f._bindMultiple.call(f, d, g, S), f;
    }, U.prototype.unbind = function(d, g) {
      var S = this;
      return S.bind.call(S, d, function() {
      }, g);
    }, U.prototype.trigger = function(d, g) {
      var S = this;
      return S._directMap[d + ":" + g] && S._directMap[d + ":" + g]({}, d), S;
    }, U.prototype.reset = function() {
      var d = this;
      return d._callbacks = {}, d._directMap = {}, d;
    }, U.prototype.stopCallback = function(d, g) {
      var S = this;
      if ((" " + g.className + " ").indexOf(" mousetrap ") > -1 || Q(g, S.target))
        return !1;
      if ("composedPath" in d && typeof d.composedPath == "function") {
        var f = d.composedPath()[0];
        f !== d.target && (g = f);
      }
      return g.tagName == "INPUT" || g.tagName == "SELECT" || g.tagName == "TEXTAREA" || g.isContentEditable;
    }, U.prototype.handleKey = function() {
      var d = this;
      return d._handleKey.apply(d, arguments);
    }, U.addKeycodes = function(d) {
      for (var g in d)
        d.hasOwnProperty(g) && (o[g] = d[g]);
      s = null;
    }, U.init = function() {
      var d = U(n);
      for (var g in d)
        g.charAt(0) !== "_" && (U[g] = /* @__PURE__ */ function(S) {
          return function() {
            return d[S].apply(d, arguments);
          };
        }(g));
    }, U.init(), e.Mousetrap = U, t.exports && (t.exports = U);
  })(typeof window < "u" ? window : null, typeof window < "u" ? document : null);
})(_n);
var er = _n.exports;
const Nt = /* @__PURE__ */ Qn(er);
function tr(t) {
  let e, n, r;
  return {
    c() {
      e = at("svg"), n = at("line"), r = at("line"), C(n, "x1", "18"), C(n, "x2", "6"), C(n, "y1", "6"), C(n, "y2", "18"), C(r, "x1", "6"), C(r, "x2", "18"), C(r, "y1", "6"), C(r, "y2", "18"), C(e, "xmlns", "http://www.w3.org/2000/svg"), C(e, "width", "20"), C(e, "height", "20"), C(e, "viewBox", "0 0 24 24"), C(e, "fill", "none"), C(e, "stroke", "white"), C(e, "stroke-width", "2"), C(e, "stroke-linecap", "round"), C(e, "stroke-linejoin", "round"), C(e, "class", "lucide lucide-x");
    },
    m(o, a) {
      J(o, e, a), T(e, n), T(e, r);
    },
    p: z,
    i: z,
    o: z,
    d(o) {
      o && $(e);
    }
  };
}
class nr extends pe {
  constructor(e) {
    super(), be(this, e, null, tr, ue, {});
  }
}
function rr(t) {
  Ce(t, "svelte-1caoogl", "label.svelte-1caoogl.svelte-1caoogl{display:flex;flex-direction:column;margin:10px 0}select.svelte-1caoogl.svelte-1caoogl{-webkit-appearance:none;padding:7px 40px 7px 12px;width:100%;border-radius:5px;border:1px solid hsl(252, 4%, 45.2%);background:transparent;cursor:pointer;font-family:inherit;font-size:16px;transition:all 150ms ease;margin-top:5px;color:var(--pink)}select.svelte-1caoogl.svelte-1caoogl:required:invalid{color:#5a667f}select.svelte-1caoogl option.svelte-1caoogl{color:#223254}select.svelte-1caoogl.svelte-1caoogl:focus{outline:none;border-color:var(--pink);box-shadow:0 0 0 2px rgba(var(--pink), 0.2)}");
}
function Ft(t, e, n) {
  const r = t.slice();
  return r[6] = e[n], r;
}
function It(t) {
  let e, n = (
    /*option*/
    t[6].label + ""
  ), r, o;
  return {
    c() {
      e = R("option"), r = re(n), e.__value = o = /*option*/
      t[6].value, e.value = e.__value, C(e, "class", "svelte-1caoogl");
    },
    m(a, i) {
      J(a, e, i), T(e, r);
    },
    p(a, i) {
      i & /*options*/
      2 && n !== (n = /*option*/
      a[6].label + "") && Oe(r, n), i & /*options*/
      2 && o !== (o = /*option*/
      a[6].value) && (e.__value = o, e.value = e.__value);
    },
    d(a) {
      a && $(e);
    }
  };
}
function or(t) {
  let e, n, r, o, a, i, u = (
    /*options*/
    t[1]
  ), s = [];
  for (let l = 0; l < u.length; l += 1)
    s[l] = It(Ft(t, u, l));
  return {
    c() {
      e = R("label"), n = re(
        /*label*/
        t[2]
      ), r = Y(), o = R("select");
      for (let l = 0; l < s.length; l += 1)
        s[l].c();
      C(o, "class", "svelte-1caoogl"), /*value*/
      t[0] === void 0 && ie(() => (
        /*select_change_handler*/
        t[4].call(o)
      )), C(e, "class", "svelte-1caoogl");
    },
    m(l, v) {
      J(l, e, v), T(e, n), T(e, r), T(e, o);
      for (let c = 0; c < s.length; c += 1)
        s[c] && s[c].m(o, null);
      jt(
        o,
        /*value*/
        t[0],
        !0
      ), a || (i = [
        le(
          o,
          "change",
          /*select_change_handler*/
          t[4]
        ),
        le(
          o,
          "change",
          /*change_handler*/
          t[5]
        )
      ], a = !0);
    },
    p(l, [v]) {
      if (v & /*label*/
      4 && Oe(
        n,
        /*label*/
        l[2]
      ), v & /*options*/
      2) {
        u = /*options*/
        l[1];
        let c;
        for (c = 0; c < u.length; c += 1) {
          const h = Ft(l, u, c);
          s[c] ? s[c].p(h, v) : (s[c] = It(h), s[c].c(), s[c].m(o, null));
        }
        for (; c < s.length; c += 1)
          s[c].d(1);
        s.length = u.length;
      }
      v & /*value, options*/
      3 && jt(
        o,
        /*value*/
        l[0]
      );
    },
    i: z,
    o: z,
    d(l) {
      l && $(e), Ve(s, l), a = !1, ee(i);
    }
  };
}
function ir(t, e, n) {
  let { options: r = [] } = e, { value: o } = e, { label: a } = e, { onChange: i } = e;
  function u() {
    o = Vn(this), n(0, o), n(1, r);
  }
  const s = (l) => {
    i(l.currentTarget.value);
  };
  return t.$$set = (l) => {
    "options" in l && n(1, r = l.options), "value" in l && n(0, o = l.value), "label" in l && n(2, a = l.label), "onChange" in l && n(3, i = l.onChange);
  }, [o, r, a, i, u, s];
}
class ar extends pe {
  constructor(e) {
    super(), be(
      this,
      e,
      ir,
      or,
      ue,
      {
        options: 1,
        value: 0,
        label: 2,
        onChange: 3
      },
      rr
    );
  }
}
function lr(t) {
  Ce(t, "svelte-umfgod", '.abby-switch.svelte-umfgod.svelte-umfgod.svelte-umfgod{all:unset;height:0;width:0;visibility:hidden}.switch.svelte-umfgod.svelte-umfgod.svelte-umfgod{display:flex;align-items:center;margin:10px 0}.switch.svelte-umfgod label.svelte-umfgod.svelte-umfgod{margin-right:10px}.switch.svelte-umfgod .abby-label.svelte-umfgod.svelte-umfgod{cursor:pointer;text-indent:-9999px;width:45px;height:25px;background:rgba(249, 168, 212, 0.3);display:block;border-radius:25px;position:relative;transition:background 0.1s ease-in-out}.switch.svelte-umfgod .abby-label.svelte-umfgod.svelte-umfgod:after{content:"";position:absolute;top:2.25px;left:2px;width:20px;height:20px;background:#fff;border-radius:50px;transition:0.3s}.switch.svelte-umfgod .abby-switch.svelte-umfgod:checked+.abby-label.svelte-umfgod{background:var(--pink)}.switch.svelte-umfgod .abby-switch.svelte-umfgod:checked+.abby-label.svelte-umfgod:after{left:calc(100% - 2px);transform:translateX(-100%)}.switch.svelte-umfgod .abby-label.svelte-umfgod.svelte-umfgod:active:after{width:25px}');
}
function sr(t) {
  let e, n, r, o, a, i, u, s;
  return {
    c() {
      e = R("div"), n = R("input"), r = R("label"), o = re(
        /*label*/
        t[2]
      ), a = Y(), i = re(
        /*label*/
        t[2]
      ), C(n, "type", "checkbox"), C(n, "class", "abby-switch svelte-umfgod"), C(
        n,
        "id",
        /*id*/
        t[1]
      ), C(r, "class", "abby-label svelte-umfgod"), C(
        r,
        "for",
        /*id*/
        t[1]
      ), C(e, "class", "switch svelte-umfgod");
    },
    m(l, v) {
      J(l, e, v), T(e, n), n.checked = /*checked*/
      t[0], T(e, r), T(r, o), T(e, a), T(e, i), u || (s = [
        le(
          n,
          "change",
          /*input_change_handler*/
          t[4]
        ),
        le(
          n,
          "change",
          /*change_handler*/
          t[5]
        )
      ], u = !0);
    },
    p(l, [v]) {
      v & /*id*/
      2 && C(
        n,
        "id",
        /*id*/
        l[1]
      ), v & /*checked*/
      1 && (n.checked = /*checked*/
      l[0]), v & /*label*/
      4 && Oe(
        o,
        /*label*/
        l[2]
      ), v & /*id*/
      2 && C(
        r,
        "for",
        /*id*/
        l[1]
      ), v & /*label*/
      4 && Oe(
        i,
        /*label*/
        l[2]
      );
    },
    i: z,
    o: z,
    d(l) {
      l && $(e), u = !1, ee(s);
    }
  };
}
function ur(t, e, n) {
  let { id: r } = e, { label: o } = e, { checked: a = !1 } = e, { onChange: i } = e;
  function u() {
    a = this.checked, n(0, a);
  }
  const s = (l) => {
    i(l.currentTarget.checked);
  };
  return t.$$set = (l) => {
    "id" in l && n(1, r = l.id), "label" in l && n(2, o = l.label), "checked" in l && n(0, a = l.checked), "onChange" in l && n(3, i = l.onChange);
  }, [a, r, o, i, u, s];
}
class cr extends pe {
  constructor(e) {
    super(), be(this, e, ur, sr, ue, { id: 1, label: 2, checked: 0, onChange: 3 }, lr);
  }
}
function wn(t) {
  const e = t - 1;
  return e * e * e + 1;
}
function fr(t) {
  return (t *= 2) < 1 ? 0.5 * t * t * t * t * t : 0.5 * ((t -= 2) * t * t * t * t + 2);
}
function dr(t, e) {
  var n = {};
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(t); o < r.length; o++)
      e.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[o]) && (n[r[o]] = t[r[o]]);
  return n;
}
function Mt(t, { delay: e = 0, duration: n = 400, easing: r = wn, start: o = 0, opacity: a = 0 } = {}) {
  const i = getComputedStyle(t), u = +i.opacity, s = i.transform === "none" ? "" : i.transform, l = 1 - o, v = u * (1 - a);
  return {
    delay: e,
    duration: n,
    easing: r,
    css: (c, h) => `
			transform: ${s} scale(${1 - l * h});
			opacity: ${u - v * h}
		`
  };
}
function vr(t) {
  var { fallback: e } = t, n = dr(t, ["fallback"]);
  const r = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Map();
  function a(u, s, l) {
    const { delay: v = 0, duration: c = (d) => Math.sqrt(d) * 30, easing: h = wn } = Me(Me({}, n), l), b = u.getBoundingClientRect(), x = s.getBoundingClientRect(), P = b.left - x.left, w = b.top - x.top, N = b.width / x.width, A = b.height / x.height, y = Math.sqrt(P * P + w * w), F = getComputedStyle(s), Q = F.transform === "none" ? "" : F.transform, U = +F.opacity;
    return {
      delay: v,
      duration: se(c) ? c(y) : c,
      easing: h,
      css: (d, g) => `
				opacity: ${d * U};
				transform-origin: top left;
				transform: ${Q} translate(${g * P}px,${g * w}px) scale(${d + (1 - d) * N}, ${d + (1 - d) * A});
			`
    };
  }
  function i(u, s, l) {
    return (v, c) => (u.set(c.key, v), () => {
      if (s.has(c.key)) {
        const h = s.get(c.key);
        return s.delete(c.key), a(h, v, c);
      }
      return u.delete(c.key), e && e(v, c, l);
    });
  }
  return [
    i(o, r, !1),
    i(r, o, !0)
  ];
}
function br(t) {
  Ce(t, "svelte-10pt5qf", "label.svelte-10pt5qf{display:flex;flex-direction:column;margin:10px 0}input.svelte-10pt5qf{padding:7px 40px 7px 12px;width:100%;border-radius:5px;border:1px solid hsl(252, 4%, 45.2%);background:transparent;font-family:inherit;font-size:16px;transition:all 150ms ease;margin-top:5px;color:var(--pink);box-sizing:border-box}input.svelte-10pt5qf:required:invalid{color:#5a667f}input.svelte-10pt5qf:focus{outline:none;border-color:var(--pink);box-shadow:0 0 0 2px rgba(var(--pink), 0.2)}");
}
function pr(t) {
  let e, n, r, o, a, i;
  return {
    c() {
      e = R("label"), n = re(
        /*label*/
        t[3]
      ), r = Y(), o = R("input"), C(
        o,
        "id",
        /*id*/
        t[4]
      ), C(
        o,
        "type",
        /*type*/
        t[0]
      ), o.value = /*value*/
      t[2], C(o, "class", "svelte-10pt5qf"), C(e, "class", "svelte-10pt5qf");
    },
    m(u, s) {
      J(u, e, s), T(e, n), T(e, r), T(e, o), a || (i = le(
        o,
        "change",
        /*change_handler*/
        t[5]
      ), a = !0);
    },
    p(u, [s]) {
      s & /*label*/
      8 && Oe(
        n,
        /*label*/
        u[3]
      ), s & /*id*/
      16 && C(
        o,
        "id",
        /*id*/
        u[4]
      ), s & /*type*/
      1 && C(
        o,
        "type",
        /*type*/
        u[0]
      ), s & /*value*/
      4 && o.value !== /*value*/
      u[2] && (o.value = /*value*/
      u[2]);
    },
    i: z,
    o: z,
    d(u) {
      u && $(e), a = !1, i();
    }
  };
}
function hr(t, e, n) {
  let { type: r = "text" } = e, { onChange: o } = e, { value: a } = e, { label: i } = e, { id: u } = e;
  const s = (l) => {
    if (r === "number") {
      o(l.currentTarget.valueAsNumber);
      return;
    }
    o(l.currentTarget.value);
  };
  return t.$$set = (l) => {
    "type" in l && n(0, r = l.type), "onChange" in l && n(1, o = l.onChange), "value" in l && n(2, a = l.value), "label" in l && n(3, i = l.label), "id" in l && n(4, u = l.id);
  }, [r, o, a, i, u, s];
}
class gr extends pe {
  constructor(e) {
    super(), be(
      this,
      e,
      hr,
      pr,
      ue,
      {
        type: 0,
        onChange: 1,
        value: 2,
        label: 3,
        id: 4
      },
      br
    );
  }
}
const me = [];
function kn(t, e) {
  return {
    subscribe: Se(t, e).subscribe
  };
}
function Se(t, e = z) {
  let n;
  const r = /* @__PURE__ */ new Set();
  function o(u) {
    if (ue(t, u) && (t = u, n)) {
      const s = !me.length;
      for (const l of r)
        l[1](), me.push(l, t);
      if (s) {
        for (let l = 0; l < me.length; l += 2)
          me[l][0](me[l + 1]);
        me.length = 0;
      }
    }
  }
  function a(u) {
    o(u(t));
  }
  function i(u, s = z) {
    const l = [u, s];
    return r.add(l), r.size === 1 && (n = e(o) || z), u(t), () => {
      r.delete(l), r.size === 0 && n && (n(), n = null);
    };
  }
  return { set: o, update: a, subscribe: i };
}
function Ge(t, e, n) {
  const r = !Array.isArray(t), o = r ? [t] : t, a = e.length < 2;
  return kn(n, (i) => {
    let u = !1;
    const s = [];
    let l = 0, v = z;
    const c = () => {
      if (l)
        return;
      v();
      const b = e(r ? s[0] : s, i);
      a ? i(b) : v = se(b) ? b : z;
    }, h = o.map((b, x) => wt(b, (P) => {
      s[x] = P, l &= ~(1 << x), u && c();
    }, () => {
      l |= 1 << x;
    }));
    return u = !0, c(), function() {
      ee(h), v(), u = !1;
    };
  });
}
function mr(t, e) {
  let n = [];
  const r = (i) => {
    n.push(i);
  }, o = () => {
    n.forEach((i) => i()), n = [];
  }, a = Ge(t, (i) => (o(), e(i, r)));
  return ot(o), a;
}
function st(t, e) {
  const n = mr(t, (r, o) => ({
    stores: r,
    onUnsubscribe: o
  })).subscribe(({ stores: r, onUnsubscribe: o }) => {
    const a = e(r);
    a && o(a);
  });
  return ot(n), n;
}
const yr = (t) => new Proxy(t, {
  get(e, n, r) {
    return Reflect.get(e, n, r);
  },
  ownKeys(e) {
    return Reflect.ownKeys(e).filter((n) => n !== "action");
  }
}), Rt = typeof document < "u";
function Ye(t, e, n, r) {
  const o = Array.isArray(e) ? [...e] : [e];
  return o.forEach((a) => t.addEventListener(a, n, r)), () => {
    o.forEach((a) => t.removeEventListener(a, n, r));
  };
}
function _r(t) {
  return new Promise((e) => setTimeout(e, t));
}
function Lt(t) {
  return {
    subscribe: t.subscribe
  };
}
function wr(t) {
  return Object.keys(t).reduce((e, n) => t[n] === void 0 ? e : e + `${n}:${t[n]};`, "");
}
let kr = (t = 21) => crypto.getRandomValues(new Uint8Array(t)).reduce((e, n) => (n &= 63, n < 36 ? e += n.toString(36) : n < 62 ? e += (n - 26).toString(36).toUpperCase() : n > 62 ? e += "-" : e += "_", e), "");
function ut() {
  return kr(10);
}
function xn() {
}
const Sn = () => typeof window < "u";
function xr() {
  const t = navigator.userAgentData;
  return (t == null ? void 0 : t.platform) ?? navigator.platform;
}
const On = (t) => Sn() && t.test(xr()), Sr = () => Sn() && !!navigator.maxTouchPoints, Or = () => On(/^Mac/) && !Sr(), Cr = () => On(/mac|iphone|ipad|ipod/i), Er = () => Cr() && !Or(), ct = "data-melt-scroll-lock";
function qt(t, e) {
  if (!t)
    return;
  const n = t.style.cssText;
  return Object.assign(t.style, e), () => {
    t.style.cssText = n;
  };
}
function Tr(t, e, n) {
  if (!t)
    return;
  const r = t.style.getPropertyValue(e);
  return t.style.setProperty(e, n), () => {
    r ? t.style.setProperty(e, r) : t.style.removeProperty(e);
  };
}
function Pr(t) {
  const e = t.getBoundingClientRect().left;
  return Math.round(e) + t.scrollLeft ? "paddingLeft" : "paddingRight";
}
function jr(t) {
  const e = document, n = e.defaultView ?? window, { documentElement: r, body: o } = e;
  if (o.hasAttribute(ct))
    return xn;
  o.setAttribute(ct, "");
  const i = n.innerWidth - r.clientWidth, u = () => Tr(r, "--scrollbar-width", `${i}px`), s = Pr(r), l = () => qt(o, {
    overflow: "hidden",
    [s]: `${i}px`
  }), v = () => {
    const { scrollX: h, scrollY: b, visualViewport: x } = n, P = (x == null ? void 0 : x.offsetLeft) ?? 0, w = (x == null ? void 0 : x.offsetTop) ?? 0, N = qt(o, {
      position: "fixed",
      overflow: "hidden",
      top: `${-(b - Math.floor(w))}px`,
      left: `${-(h - Math.floor(P))}px`,
      right: "0",
      [s]: `${i}px`
    });
    return () => {
      N == null || N(), n.scrollTo(h, b);
    };
  }, c = [u(), Er() ? v() : l()];
  return () => {
    c.forEach((h) => h == null ? void 0 : h()), o.removeAttribute(ct);
  };
}
kn(void 0, (t) => {
  function e(r) {
    t(r), t(void 0);
  }
  return Ye(document, "pointerdown", e, {
    passive: !1,
    capture: !0
  });
});
/*!
* tabbable 6.2.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
var Cn = ["input:not([inert])", "select:not([inert])", "textarea:not([inert])", "a[href]:not([inert])", "button:not([inert])", "[tabindex]:not(slot):not([inert])", "audio[controls]:not([inert])", "video[controls]:not([inert])", '[contenteditable]:not([contenteditable="false"]):not([inert])', "details>summary:first-of-type:not([inert])", "details:not([inert])"], Ze = /* @__PURE__ */ Cn.join(","), En = typeof Element > "u", fe = En ? function() {
} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector, Qe = !En && Element.prototype.getRootNode ? function(t) {
  var e;
  return t == null || (e = t.getRootNode) === null || e === void 0 ? void 0 : e.call(t);
} : function(t) {
  return t == null ? void 0 : t.ownerDocument;
}, et = function t(e, n) {
  var r;
  n === void 0 && (n = !0);
  var o = e == null || (r = e.getAttribute) === null || r === void 0 ? void 0 : r.call(e, "inert"), a = o === "" || o === "true", i = a || n && e && t(e.parentNode);
  return i;
}, Ar = function(e) {
  var n, r = e == null || (n = e.getAttribute) === null || n === void 0 ? void 0 : n.call(e, "contenteditable");
  return r === "" || r === "true";
}, Tn = function(e, n, r) {
  if (et(e))
    return [];
  var o = Array.prototype.slice.apply(e.querySelectorAll(Ze));
  return n && fe.call(e, Ze) && o.unshift(e), o = o.filter(r), o;
}, Pn = function t(e, n, r) {
  for (var o = [], a = Array.from(e); a.length; ) {
    var i = a.shift();
    if (!et(i, !1))
      if (i.tagName === "SLOT") {
        var u = i.assignedElements(), s = u.length ? u : i.children, l = t(s, !0, r);
        r.flatten ? o.push.apply(o, l) : o.push({
          scopeParent: i,
          candidates: l
        });
      } else {
        var v = fe.call(i, Ze);
        v && r.filter(i) && (n || !e.includes(i)) && o.push(i);
        var c = i.shadowRoot || // check for an undisclosed shadow
        typeof r.getShadowRoot == "function" && r.getShadowRoot(i), h = !et(c, !1) && (!r.shadowRootFilter || r.shadowRootFilter(i));
        if (c && h) {
          var b = t(c === !0 ? i.children : c.children, !0, r);
          r.flatten ? o.push.apply(o, b) : o.push({
            scopeParent: i,
            candidates: b
          });
        } else
          a.unshift.apply(a, i.children);
      }
  }
  return o;
}, jn = function(e) {
  return !isNaN(parseInt(e.getAttribute("tabindex"), 10));
}, An = function(e) {
  if (!e)
    throw new Error("No node provided");
  return e.tabIndex < 0 && (/^(AUDIO|VIDEO|DETAILS)$/.test(e.tagName) || Ar(e)) && !jn(e) ? 0 : e.tabIndex;
}, Dr = function(e, n) {
  var r = An(e);
  return r < 0 && n && !jn(e) ? 0 : r;
}, Nr = function(e, n) {
  return e.tabIndex === n.tabIndex ? e.documentOrder - n.documentOrder : e.tabIndex - n.tabIndex;
}, Dn = function(e) {
  return e.tagName === "INPUT";
}, Fr = function(e) {
  return Dn(e) && e.type === "hidden";
}, Ir = function(e) {
  var n = e.tagName === "DETAILS" && Array.prototype.slice.apply(e.children).some(function(r) {
    return r.tagName === "SUMMARY";
  });
  return n;
}, Mr = function(e, n) {
  for (var r = 0; r < e.length; r++)
    if (e[r].checked && e[r].form === n)
      return e[r];
}, Rr = function(e) {
  if (!e.name)
    return !0;
  var n = e.form || Qe(e), r = function(u) {
    return n.querySelectorAll('input[type="radio"][name="' + u + '"]');
  }, o;
  if (typeof window < "u" && typeof window.CSS < "u" && typeof window.CSS.escape == "function")
    o = r(window.CSS.escape(e.name));
  else
    try {
      o = r(e.name);
    } catch (i) {
      return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", i.message), !1;
    }
  var a = Mr(o, e.form);
  return !a || a === e;
}, Lr = function(e) {
  return Dn(e) && e.type === "radio";
}, qr = function(e) {
  return Lr(e) && !Rr(e);
}, Kr = function(e) {
  var n, r = e && Qe(e), o = (n = r) === null || n === void 0 ? void 0 : n.host, a = !1;
  if (r && r !== e) {
    var i, u, s;
    for (a = !!((i = o) !== null && i !== void 0 && (u = i.ownerDocument) !== null && u !== void 0 && u.contains(o) || e != null && (s = e.ownerDocument) !== null && s !== void 0 && s.contains(e)); !a && o; ) {
      var l, v, c;
      r = Qe(o), o = (l = r) === null || l === void 0 ? void 0 : l.host, a = !!((v = o) !== null && v !== void 0 && (c = v.ownerDocument) !== null && c !== void 0 && c.contains(o));
    }
  }
  return a;
}, Kt = function(e) {
  var n = e.getBoundingClientRect(), r = n.width, o = n.height;
  return r === 0 && o === 0;
}, Br = function(e, n) {
  var r = n.displayCheck, o = n.getShadowRoot;
  if (getComputedStyle(e).visibility === "hidden")
    return !0;
  var a = fe.call(e, "details>summary:first-of-type"), i = a ? e.parentElement : e;
  if (fe.call(i, "details:not([open]) *"))
    return !0;
  if (!r || r === "full" || r === "legacy-full") {
    if (typeof o == "function") {
      for (var u = e; e; ) {
        var s = e.parentElement, l = Qe(e);
        if (s && !s.shadowRoot && o(s) === !0)
          return Kt(e);
        e.assignedSlot ? e = e.assignedSlot : !s && l !== e.ownerDocument ? e = l.host : e = s;
      }
      e = u;
    }
    if (Kr(e))
      return !e.getClientRects().length;
    if (r !== "legacy-full")
      return !0;
  } else if (r === "non-zero-area")
    return Kt(e);
  return !1;
}, zr = function(e) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(e.tagName))
    for (var n = e.parentElement; n; ) {
      if (n.tagName === "FIELDSET" && n.disabled) {
        for (var r = 0; r < n.children.length; r++) {
          var o = n.children.item(r);
          if (o.tagName === "LEGEND")
            return fe.call(n, "fieldset[disabled] *") ? !0 : !o.contains(e);
        }
        return !0;
      }
      n = n.parentElement;
    }
  return !1;
}, tt = function(e, n) {
  return !(n.disabled || // we must do an inert look up to filter out any elements inside an inert ancestor
  //  because we're limited in the type of selectors we can use in JSDom (see related
  //  note related to `candidateSelectors`)
  et(n) || Fr(n) || Br(n, e) || // For a details element with a summary, the summary element gets the focus
  Ir(n) || zr(n));
}, mt = function(e, n) {
  return !(qr(n) || An(n) < 0 || !tt(e, n));
}, Ur = function(e) {
  var n = parseInt(e.getAttribute("tabindex"), 10);
  return !!(isNaN(n) || n >= 0);
}, Vr = function t(e) {
  var n = [], r = [];
  return e.forEach(function(o, a) {
    var i = !!o.scopeParent, u = i ? o.scopeParent : o, s = Dr(u, i), l = i ? t(o.candidates) : u;
    s === 0 ? i ? n.push.apply(n, l) : n.push(u) : r.push({
      documentOrder: a,
      tabIndex: s,
      item: o,
      isScope: i,
      content: l
    });
  }), r.sort(Nr).reduce(function(o, a) {
    return a.isScope ? o.push.apply(o, a.content) : o.push(a.content), o;
  }, []).concat(n);
}, Wr = function(e, n) {
  n = n || {};
  var r;
  return n.getShadowRoot ? r = Pn([e], n.includeContainer, {
    filter: mt.bind(null, n),
    flatten: !1,
    getShadowRoot: n.getShadowRoot,
    shadowRootFilter: Ur
  }) : r = Tn(e, n.includeContainer, mt.bind(null, n)), Vr(r);
}, Gr = function(e, n) {
  n = n || {};
  var r;
  return n.getShadowRoot ? r = Pn([e], n.includeContainer, {
    filter: tt.bind(null, n),
    flatten: !0,
    getShadowRoot: n.getShadowRoot
  }) : r = Tn(e, n.includeContainer, tt.bind(null, n)), r;
}, Be = function(e, n) {
  if (n = n || {}, !e)
    throw new Error("No node provided");
  return fe.call(e, Ze) === !1 ? !1 : mt(n, e);
}, Yr = /* @__PURE__ */ Cn.concat("iframe").join(","), ft = function(e, n) {
  if (n = n || {}, !e)
    throw new Error("No node provided");
  return fe.call(e, Yr) === !1 ? !1 : tt(n, e);
};
/*!
* focus-trap 7.4.3
* @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
*/
function Bt(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(t, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function zt(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Bt(Object(n), !0).forEach(function(r) {
      $r(t, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : Bt(Object(n)).forEach(function(r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return t;
}
function $r(t, e, n) {
  return e = Xr(e), e in t ? Object.defineProperty(t, e, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = n, t;
}
function Hr(t, e) {
  if (typeof t != "object" || t === null)
    return t;
  var n = t[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(t, e);
    if (typeof r != "object")
      return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
function Xr(t) {
  var e = Hr(t, "string");
  return typeof e == "symbol" ? e : String(e);
}
var Ut = {
  activateTrap: function(e, n) {
    if (e.length > 0) {
      var r = e[e.length - 1];
      r !== n && r.pause();
    }
    var o = e.indexOf(n);
    o === -1 || e.splice(o, 1), e.push(n);
  },
  deactivateTrap: function(e, n) {
    var r = e.indexOf(n);
    r !== -1 && e.splice(r, 1), e.length > 0 && e[e.length - 1].unpause();
  }
}, Jr = function(e) {
  return e.tagName && e.tagName.toLowerCase() === "input" && typeof e.select == "function";
}, Zr = function(e) {
  return e.key === "Escape" || e.key === "Esc" || e.keyCode === 27;
}, Ie = function(e) {
  return e.key === "Tab" || e.keyCode === 9;
}, Qr = function(e) {
  return Ie(e) && !e.shiftKey;
}, eo = function(e) {
  return Ie(e) && e.shiftKey;
}, Vt = function(e) {
  return setTimeout(e, 0);
}, Wt = function(e, n) {
  var r = -1;
  return e.every(function(o, a) {
    return n(o) ? (r = a, !1) : !0;
  }), r;
}, Pe = function(e) {
  for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), o = 1; o < n; o++)
    r[o - 1] = arguments[o];
  return typeof e == "function" ? e.apply(void 0, r) : e;
}, ze = function(e) {
  return e.target.shadowRoot && typeof e.composedPath == "function" ? e.composedPath()[0] : e.target;
}, to = [], no = function(e, n) {
  var r = (n == null ? void 0 : n.document) || document, o = (n == null ? void 0 : n.trapStack) || to, a = zt({
    returnFocusOnDeactivate: !0,
    escapeDeactivates: !0,
    delayInitialFocus: !0,
    isKeyForward: Qr,
    isKeyBackward: eo
  }, n), i = {
    // containers given to createFocusTrap()
    // @type {Array<HTMLElement>}
    containers: [],
    // list of objects identifying tabbable nodes in `containers` in the trap
    // NOTE: it's possible that a group has no tabbable nodes if nodes get removed while the trap
    //  is active, but the trap should never get to a state where there isn't at least one group
    //  with at least one tabbable node in it (that would lead to an error condition that would
    //  result in an error being thrown)
    // @type {Array<{
    //   container: HTMLElement,
    //   tabbableNodes: Array<HTMLElement>, // empty if none
    //   focusableNodes: Array<HTMLElement>, // empty if none
    //   firstTabbableNode: HTMLElement|null,
    //   lastTabbableNode: HTMLElement|null,
    //   nextTabbableNode: (node: HTMLElement, forward: boolean) => HTMLElement|undefined
    // }>}
    containerGroups: [],
    // same order/length as `containers` list
    // references to objects in `containerGroups`, but only those that actually have
    //  tabbable nodes in them
    // NOTE: same order as `containers` and `containerGroups`, but __not necessarily__
    //  the same length
    tabbableGroups: [],
    nodeFocusedBeforeActivation: null,
    mostRecentlyFocusedNode: null,
    active: !1,
    paused: !1,
    // timer ID for when delayInitialFocus is true and initial focus in this trap
    //  has been delayed during activation
    delayInitialFocusTimer: void 0
  }, u, s = function(f, p, k) {
    return f && f[p] !== void 0 ? f[p] : a[k || p];
  }, l = function(f, p) {
    var k = typeof (p == null ? void 0 : p.composedPath) == "function" ? p.composedPath() : void 0;
    return i.containerGroups.findIndex(function(M) {
      var L = M.container, B = M.tabbableNodes;
      return L.contains(f) || // fall back to explicit tabbable search which will take into consideration any
      //  web components if the `tabbableOptions.getShadowRoot` option was used for
      //  the trap, enabling shadow DOM support in tabbable (`Node.contains()` doesn't
      //  look inside web components even if open)
      (k == null ? void 0 : k.includes(L)) || B.find(function(V) {
        return V === f;
      });
    });
  }, v = function(f) {
    var p = a[f];
    if (typeof p == "function") {
      for (var k = arguments.length, M = new Array(k > 1 ? k - 1 : 0), L = 1; L < k; L++)
        M[L - 1] = arguments[L];
      p = p.apply(void 0, M);
    }
    if (p === !0 && (p = void 0), !p) {
      if (p === void 0 || p === !1)
        return p;
      throw new Error("`".concat(f, "` was specified but was not a node, or did not return a node"));
    }
    var B = p;
    if (typeof p == "string" && (B = r.querySelector(p), !B))
      throw new Error("`".concat(f, "` as selector refers to no known node"));
    return B;
  }, c = function() {
    var f = v("initialFocus");
    if (f === !1)
      return !1;
    if (f === void 0 || !ft(f, a.tabbableOptions))
      if (l(r.activeElement) >= 0)
        f = r.activeElement;
      else {
        var p = i.tabbableGroups[0], k = p && p.firstTabbableNode;
        f = k || v("fallbackFocus");
      }
    if (!f)
      throw new Error("Your focus-trap needs to have at least one focusable element");
    return f;
  }, h = function() {
    if (i.containerGroups = i.containers.map(function(f) {
      var p = Wr(f, a.tabbableOptions), k = Gr(f, a.tabbableOptions);
      return {
        container: f,
        tabbableNodes: p,
        focusableNodes: k,
        firstTabbableNode: p.length > 0 ? p[0] : null,
        lastTabbableNode: p.length > 0 ? p[p.length - 1] : null,
        /**
         * Finds the __tabbable__ node that follows the given node in the specified direction,
         *  in this container, if any.
         * @param {HTMLElement} node
         * @param {boolean} [forward] True if going in forward tab order; false if going
         *  in reverse.
         * @returns {HTMLElement|undefined} The next tabbable node, if any.
         */
        nextTabbableNode: function(L) {
          var B = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0, V = k.findIndex(function(Z) {
            return Z === L;
          });
          if (!(V < 0))
            return B ? k.slice(V + 1).find(function(Z) {
              return Be(Z, a.tabbableOptions);
            }) : k.slice(0, V).reverse().find(function(Z) {
              return Be(Z, a.tabbableOptions);
            });
        }
      };
    }), i.tabbableGroups = i.containerGroups.filter(function(f) {
      return f.tabbableNodes.length > 0;
    }), i.tabbableGroups.length <= 0 && !v("fallbackFocus"))
      throw new Error("Your focus-trap must have at least one container with at least one tabbable node in it at all times");
  }, b = function S(f) {
    if (f !== !1 && f !== r.activeElement) {
      if (!f || !f.focus) {
        S(c());
        return;
      }
      f.focus({
        preventScroll: !!a.preventScroll
      }), i.mostRecentlyFocusedNode = f, Jr(f) && f.select();
    }
  }, x = function(f) {
    var p = v("setReturnFocus", f);
    return p || (p === !1 ? !1 : f);
  }, P = function(f) {
    var p = ze(f);
    if (!(l(p, f) >= 0)) {
      if (Pe(a.clickOutsideDeactivates, f)) {
        u.deactivate({
          // NOTE: by setting `returnFocus: false`, deactivate() will do nothing,
          //  which will result in the outside click setting focus to the node
          //  that was clicked (and if not focusable, to "nothing"); by setting
          //  `returnFocus: true`, we'll attempt to re-focus the node originally-focused
          //  on activation (or the configured `setReturnFocus` node), whether the
          //  outside click was on a focusable node or not
          returnFocus: a.returnFocusOnDeactivate
        });
        return;
      }
      Pe(a.allowOutsideClick, f) || f.preventDefault();
    }
  }, w = function(f) {
    var p = ze(f), k = l(p, f) >= 0;
    k || p instanceof Document ? k && (i.mostRecentlyFocusedNode = p) : (f.stopImmediatePropagation(), b(i.mostRecentlyFocusedNode || c()));
  }, N = function(f) {
    var p = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, k = ze(f);
    h();
    var M = null;
    if (i.tabbableGroups.length > 0) {
      var L = l(k, f), B = L >= 0 ? i.containerGroups[L] : void 0;
      if (L < 0)
        p ? M = i.tabbableGroups[i.tabbableGroups.length - 1].lastTabbableNode : M = i.tabbableGroups[0].firstTabbableNode;
      else if (p) {
        var V = Wt(i.tabbableGroups, function(O) {
          var q = O.firstTabbableNode;
          return k === q;
        });
        if (V < 0 && (B.container === k || ft(k, a.tabbableOptions) && !Be(k, a.tabbableOptions) && !B.nextTabbableNode(k, !1)) && (V = L), V >= 0) {
          var Z = V === 0 ? i.tabbableGroups.length - 1 : V - 1, te = i.tabbableGroups[Z];
          M = te.lastTabbableNode;
        } else
          Ie(f) || (M = B.nextTabbableNode(k, !1));
      } else {
        var K = Wt(i.tabbableGroups, function(O) {
          var q = O.lastTabbableNode;
          return k === q;
        });
        if (K < 0 && (B.container === k || ft(k, a.tabbableOptions) && !Be(k, a.tabbableOptions) && !B.nextTabbableNode(k)) && (K = L), K >= 0) {
          var he = K === i.tabbableGroups.length - 1 ? 0 : K + 1, j = i.tabbableGroups[he];
          M = j.firstTabbableNode;
        } else
          Ie(f) || (M = B.nextTabbableNode(k));
      }
    } else
      M = v("fallbackFocus");
    M && (Ie(f) && f.preventDefault(), b(M));
  }, A = function(f) {
    if (Zr(f) && Pe(a.escapeDeactivates, f) !== !1) {
      f.preventDefault(), u.deactivate();
      return;
    }
    (a.isKeyForward(f) || a.isKeyBackward(f)) && N(f, a.isKeyBackward(f));
  }, y = function(f) {
    var p = ze(f);
    l(p, f) >= 0 || Pe(a.clickOutsideDeactivates, f) || Pe(a.allowOutsideClick, f) || (f.preventDefault(), f.stopImmediatePropagation());
  }, F = function() {
    if (i.active)
      return Ut.activateTrap(o, u), i.delayInitialFocusTimer = a.delayInitialFocus ? Vt(function() {
        b(c());
      }) : b(c()), r.addEventListener("focusin", w, !0), r.addEventListener("mousedown", P, {
        capture: !0,
        passive: !1
      }), r.addEventListener("touchstart", P, {
        capture: !0,
        passive: !1
      }), r.addEventListener("click", y, {
        capture: !0,
        passive: !1
      }), r.addEventListener("keydown", A, {
        capture: !0,
        passive: !1
      }), u;
  }, Q = function() {
    if (i.active)
      return r.removeEventListener("focusin", w, !0), r.removeEventListener("mousedown", P, !0), r.removeEventListener("touchstart", P, !0), r.removeEventListener("click", y, !0), r.removeEventListener("keydown", A, !0), u;
  }, U = function(f) {
    var p = f.some(function(k) {
      var M = Array.from(k.removedNodes);
      return M.some(function(L) {
        return L === i.mostRecentlyFocusedNode;
      });
    });
    p && b(c());
  }, d = typeof window < "u" && "MutationObserver" in window ? new MutationObserver(U) : void 0, g = function() {
    d && (d.disconnect(), i.active && !i.paused && i.containers.map(function(f) {
      d.observe(f, {
        subtree: !0,
        childList: !0
      });
    }));
  };
  return u = {
    get active() {
      return i.active;
    },
    get paused() {
      return i.paused;
    },
    activate: function(f) {
      if (i.active)
        return this;
      var p = s(f, "onActivate"), k = s(f, "onPostActivate"), M = s(f, "checkCanFocusTrap");
      M || h(), i.active = !0, i.paused = !1, i.nodeFocusedBeforeActivation = r.activeElement, p == null || p();
      var L = function() {
        M && h(), F(), g(), k == null || k();
      };
      return M ? (M(i.containers.concat()).then(L, L), this) : (L(), this);
    },
    deactivate: function(f) {
      if (!i.active)
        return this;
      var p = zt({
        onDeactivate: a.onDeactivate,
        onPostDeactivate: a.onPostDeactivate,
        checkCanReturnFocus: a.checkCanReturnFocus
      }, f);
      clearTimeout(i.delayInitialFocusTimer), i.delayInitialFocusTimer = void 0, Q(), i.active = !1, i.paused = !1, g(), Ut.deactivateTrap(o, u);
      var k = s(p, "onDeactivate"), M = s(p, "onPostDeactivate"), L = s(p, "checkCanReturnFocus"), B = s(p, "returnFocus", "returnFocusOnDeactivate");
      k == null || k();
      var V = function() {
        Vt(function() {
          B && b(x(i.nodeFocusedBeforeActivation)), M == null || M();
        });
      };
      return B && L ? (L(x(i.nodeFocusedBeforeActivation)).then(V, V), this) : (V(), this);
    },
    pause: function(f) {
      if (i.paused || !i.active)
        return this;
      var p = s(f, "onPause"), k = s(f, "onPostPause");
      return i.paused = !0, p == null || p(), Q(), g(), k == null || k(), this;
    },
    unpause: function(f) {
      if (!i.paused || !i.active)
        return this;
      var p = s(f, "onUnpause"), k = s(f, "onPostUnpause");
      return i.paused = !1, p == null || p(), h(), F(), g(), k == null || k(), this;
    },
    updateContainerElements: function(f) {
      var p = [].concat(f).filter(Boolean);
      return i.containers = p.map(function(k) {
        return typeof k == "string" ? r.querySelector(k) : k;
      }), i.active && h(), g(), this;
    }
  }, u.updateContainerElements(e), u;
};
function ro(t = {}) {
  let e;
  const { immediate: n, ...r } = t, o = Se(!1), a = Se(!1), i = (c) => e == null ? void 0 : e.activate(c), u = (c) => {
    e == null || e.deactivate(c);
  }, s = () => {
    e && (e.pause(), a.set(!0));
  }, l = () => {
    e && (e.unpause(), a.set(!1));
  };
  return {
    useFocusTrap: (c) => (e = no(c, {
      ...r,
      onActivate() {
        var h;
        o.set(!0), (h = t.onActivate) == null || h.call(t);
      },
      onDeactivate() {
        var h;
        o.set(!1), (h = t.onDeactivate) == null || h.call(t);
      }
    }), n && i(), {
      destroy() {
        u(), e = void 0;
      }
    }),
    hasFocus: Lt(o),
    isPaused: Lt(a),
    activate: i,
    deactivate: u,
    pause: s,
    unpause: l
  };
}
const oo = (t, e = "body") => {
  let n;
  async function r(a) {
    if (e = a, typeof e == "string") {
      if (n = document.querySelector(e), n === null && (await Hn(), n = document.querySelector(e)), n === null)
        throw new Error(`No element found matching css selector: "${e}"`);
    } else if (e instanceof HTMLElement)
      n = e;
    else
      throw new TypeError(`Unknown portal target type: ${e === null ? "null" : typeof e}. Allowed types: string (CSS selector) or HTMLElement.`);
    n.appendChild(t), t.hidden = !1;
  }
  function o() {
    t.remove();
  }
  return r(e), {
    update: r,
    destroy: o
  };
}, io = {
  preventScroll: !0,
  closeOnEscape: !0,
  closeOnOutsideClick: !0,
  role: "dialog"
};
function ao(t = {}) {
  const e = { ...io, ...t }, n = Se({ ...e }), r = Se(null), o = {
    content: ut(),
    title: ut(),
    description: ut()
  }, a = Se(!1), i = {
    ...Ge(a, (b) => ({
      "aria-haspopup": "dialog",
      "aria-expanded": b,
      "aria-controls": o.content,
      type: "button"
    })),
    action: (b) => ({
      destroy: Ye(b, "click", (P) => {
        const w = P.currentTarget;
        a.set(!0), r.set(w);
      })
    })
  }, u = Ge([a], ([b]) => ({
    hidden: b ? void 0 : !0,
    tabindex: -1,
    style: wr({
      display: b ? void 0 : "none"
    }),
    "aria-hidden": !0,
    "data-state": b ? "open" : "closed"
  })), l = {
    ...Ge(a, (b) => ({
      id: o.content,
      role: "dialog",
      "aria-describedby": o.description,
      "aria-labelledby": o.title,
      "data-state": b ? "open" : "closed",
      tabindex: -1,
      hidden: b ? void 0 : !0
    })),
    action: (b) => {
      let x = xn;
      const { useFocusTrap: P, activate: w, deactivate: N } = ro({
        immediate: !1,
        escapeDeactivates: !1,
        allowOutsideClick: (y) => (y.preventDefault(), Kn(n).closeOnOutsideClick && a.set(!1), !1),
        returnFocusOnDeactivate: !1,
        fallbackFocus: b
      }), A = P(b);
      return A && A.destroy ? x = A.destroy : x = N, st([a], ([y]) => {
        b.hidden || !y ? N() : w();
      }), {
        destroy: x
      };
    }
  }, v = {
    id: o.title
  }, c = {
    id: o.description
  }, h = yr({
    type: "button",
    action: (b) => ({
      destroy: Ye(b, "click", () => {
        a.set(!1);
      })
    })
  });
  return st([a, n], ([b, x]) => {
    const P = [];
    return x.closeOnEscape && b && P.push(Ye(document, "keydown", (w) => {
      w.key === "Escape" && a.set(!1);
    })), x.preventScroll && b && P.push(jr()), () => {
      P.forEach((w) => w());
    };
  }), st([a, r], ([b, x]) => {
    Rt && !b && x && Rt && _r(1).then(() => x.focus());
  }), {
    options: n,
    open: a,
    trigger: i,
    overlay: u,
    portal: oo,
    content: l,
    title: v,
    description: c,
    close: h
  };
}
function lo(t, e, n) {
  return e in t ? Object.defineProperty(t, e, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = n, t;
}
function Gt(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(t, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Yt(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Gt(Object(n), !0).forEach(function(r) {
      lo(t, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : Gt(Object(n)).forEach(function(r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return t;
}
function so(t, e) {
  if (t == null)
    return {};
  var n = {}, r = Object.keys(t), o, a;
  for (a = 0; a < r.length; a++)
    o = r[a], !(e.indexOf(o) >= 0) && (n[o] = t[o]);
  return n;
}
function uo(t, e) {
  if (t == null)
    return {};
  var n = so(t, e), r, o;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(t);
    for (o = 0; o < a.length; o++)
      r = a[o], !(e.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(t, r) && (n[r] = t[r]);
  }
  return n;
}
function co(t, e) {
  return fo(t) || vo(t, e) || bo(t, e) || po();
}
function fo(t) {
  if (Array.isArray(t))
    return t;
}
function vo(t, e) {
  if (!(typeof Symbol > "u" || !(Symbol.iterator in Object(t)))) {
    var n = [], r = !0, o = !1, a = void 0;
    try {
      for (var i = t[Symbol.iterator](), u; !(r = (u = i.next()).done) && (n.push(u.value), !(e && n.length === e)); r = !0)
        ;
    } catch (s) {
      o = !0, a = s;
    } finally {
      try {
        !r && i.return != null && i.return();
      } finally {
        if (o)
          throw a;
      }
    }
    return n;
  }
}
function bo(t, e) {
  if (t) {
    if (typeof t == "string")
      return $t(t, e);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set")
      return Array.from(t);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return $t(t, e);
  }
}
function $t(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var n = 0, r = new Array(e); n < e; n++)
    r[n] = t[n];
  return r;
}
function po() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function ho(t, e, n) {
  return e in t ? Object.defineProperty(t, e, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = n, t;
}
function Ht(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(t, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Xt(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Ht(Object(n), !0).forEach(function(r) {
      ho(t, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : Ht(Object(n)).forEach(function(r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return t;
}
function go() {
  for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++)
    e[n] = arguments[n];
  return function(r) {
    return e.reduceRight(function(o, a) {
      return a(o);
    }, r);
  };
}
function je(t) {
  return function e() {
    for (var n = this, r = arguments.length, o = new Array(r), a = 0; a < r; a++)
      o[a] = arguments[a];
    return o.length >= t.length ? t.apply(this, o) : function() {
      for (var i = arguments.length, u = new Array(i), s = 0; s < i; s++)
        u[s] = arguments[s];
      return e.apply(n, [].concat(o, u));
    };
  };
}
function nt(t) {
  return {}.toString.call(t).includes("Object");
}
function mo(t) {
  return !Object.keys(t).length;
}
function Le(t) {
  return typeof t == "function";
}
function yo(t, e) {
  return Object.prototype.hasOwnProperty.call(t, e);
}
function _o(t, e) {
  return nt(e) || ae("changeType"), Object.keys(e).some(function(n) {
    return !yo(t, n);
  }) && ae("changeField"), e;
}
function wo(t) {
  Le(t) || ae("selectorType");
}
function ko(t) {
  Le(t) || nt(t) || ae("handlerType"), nt(t) && Object.values(t).some(function(e) {
    return !Le(e);
  }) && ae("handlersType");
}
function xo(t) {
  t || ae("initialIsRequired"), nt(t) || ae("initialType"), mo(t) && ae("initialContent");
}
function So(t, e) {
  throw new Error(t[e] || t.default);
}
var Oo = {
  initialIsRequired: "initial state is required",
  initialType: "initial state should be an object",
  initialContent: "initial state shouldn't be an empty object",
  handlerType: "handler should be an object or a function",
  handlersType: "all handlers should be a functions",
  selectorType: "selector should be a function",
  changeType: "provided value of changes should be an object",
  changeField: 'it seams you want to change a field in the state which is not specified in the "initial" state',
  default: "an unknown error accured in `state-local` package"
}, ae = je(So)(Oo), Ue = {
  changes: _o,
  selector: wo,
  handler: ko,
  initial: xo
};
function Co(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  Ue.initial(t), Ue.handler(e);
  var n = {
    current: t
  }, r = je(Po)(n, e), o = je(To)(n), a = je(Ue.changes)(t), i = je(Eo)(n);
  function u() {
    var l = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : function(v) {
      return v;
    };
    return Ue.selector(l), l(n.current);
  }
  function s(l) {
    go(r, o, a, i)(l);
  }
  return [u, s];
}
function Eo(t, e) {
  return Le(e) ? e(t.current) : e;
}
function To(t, e) {
  return t.current = Xt(Xt({}, t.current), e), e;
}
function Po(t, e, n) {
  return Le(e) ? e(t.current) : Object.keys(n).forEach(function(r) {
    var o;
    return (o = e[r]) === null || o === void 0 ? void 0 : o.call(e, t.current[r]);
  }), n;
}
var jo = {
  create: Co
}, Ao = {
  paths: {
    vs: "https://cdn.jsdelivr.net/npm/monaco-editor@0.36.1/min/vs"
  }
};
function Do(t) {
  return function e() {
    for (var n = this, r = arguments.length, o = new Array(r), a = 0; a < r; a++)
      o[a] = arguments[a];
    return o.length >= t.length ? t.apply(this, o) : function() {
      for (var i = arguments.length, u = new Array(i), s = 0; s < i; s++)
        u[s] = arguments[s];
      return e.apply(n, [].concat(o, u));
    };
  };
}
function No(t) {
  return {}.toString.call(t).includes("Object");
}
function Fo(t) {
  return t || Jt("configIsRequired"), No(t) || Jt("configType"), t.urls ? (Io(), {
    paths: {
      vs: t.urls.monacoBase
    }
  }) : t;
}
function Io() {
  console.warn(Nn.deprecation);
}
function Mo(t, e) {
  throw new Error(t[e] || t.default);
}
var Nn = {
  configIsRequired: "the configuration object is required",
  configType: "the configuration object should be an object",
  default: "an unknown error accured in `@monaco-editor/loader` package",
  deprecation: `Deprecation warning!
    You are using deprecated way of configuration.

    Instead of using
      monaco.config({ urls: { monacoBase: '...' } })
    use
      monaco.config({ paths: { vs: '...' } })

    For more please check the link https://github.com/suren-atoyan/monaco-loader#config
  `
}, Jt = Do(Mo)(Nn), Ro = {
  config: Fo
}, Lo = function() {
  for (var e = arguments.length, n = new Array(e), r = 0; r < e; r++)
    n[r] = arguments[r];
  return function(o) {
    return n.reduceRight(function(a, i) {
      return i(a);
    }, o);
  };
};
function Fn(t, e) {
  return Object.keys(e).forEach(function(n) {
    e[n] instanceof Object && t[n] && Object.assign(e[n], Fn(t[n], e[n]));
  }), Yt(Yt({}, t), e);
}
var qo = {
  type: "cancelation",
  msg: "operation is manually canceled"
};
function dt(t) {
  var e = !1, n = new Promise(function(r, o) {
    t.then(function(a) {
      return e ? o(qo) : r(a);
    }), t.catch(o);
  });
  return n.cancel = function() {
    return e = !0;
  }, n;
}
var Ko = jo.create({
  config: Ao,
  isInitialized: !1,
  resolve: null,
  reject: null,
  monaco: null
}), In = co(Ko, 2), qe = In[0], it = In[1];
function Bo(t) {
  var e = Ro.config(t), n = e.monaco, r = uo(e, ["monaco"]);
  it(function(o) {
    return {
      config: Fn(o.config, r),
      monaco: n
    };
  });
}
function zo() {
  var t = qe(function(e) {
    var n = e.monaco, r = e.isInitialized, o = e.resolve;
    return {
      monaco: n,
      isInitialized: r,
      resolve: o
    };
  });
  if (!t.isInitialized) {
    if (it({
      isInitialized: !0
    }), t.monaco)
      return t.resolve(t.monaco), dt(vt);
    if (window.monaco && window.monaco.editor)
      return Mn(window.monaco), t.resolve(window.monaco), dt(vt);
    Lo(Uo, Wo)(Go);
  }
  return dt(vt);
}
function Uo(t) {
  return document.body.appendChild(t);
}
function Vo(t) {
  var e = document.createElement("script");
  return t && (e.src = t), e;
}
function Wo(t) {
  var e = qe(function(r) {
    var o = r.config, a = r.reject;
    return {
      config: o,
      reject: a
    };
  }), n = Vo("".concat(e.config.paths.vs, "/loader.js"));
  return n.onload = function() {
    return t();
  }, n.onerror = e.reject, n;
}
function Go() {
  var t = qe(function(n) {
    var r = n.config, o = n.resolve, a = n.reject;
    return {
      config: r,
      resolve: o,
      reject: a
    };
  }), e = window.require;
  e.config(t.config), e(["vs/editor/editor.main"], function(n) {
    Mn(n), t.resolve(n);
  }, function(n) {
    t.reject(n);
  });
}
function Mn(t) {
  qe().monaco || it({
    monaco: t
  });
}
function Yo() {
  return qe(function(t) {
    var e = t.monaco;
    return e;
  });
}
var vt = new Promise(function(t, e) {
  return it({
    resolve: t,
    reject: e
  });
}), Zt = {
  config: Bo,
  init: zo,
  __getMonacoInstance: Yo
};
function $o(t) {
  Ce(t, "svelte-v3q4fo", ".loading-text.svelte-v3q4fo{position:absolute;top:50%;left:50%;transform:translate(-50%, -50%)}.container.svelte-v3q4fo{height:100%;width:100%;position:relative}");
}
function Qt(t) {
  let e;
  return {
    c() {
      e = R("p"), e.textContent = "Loading...", C(e, "class", "loading-text svelte-v3q4fo");
    },
    m(n, r) {
      J(n, e, r);
    },
    d(n) {
      n && $(e);
    }
  };
}
function Ho(t) {
  let e, n = !/*isMounted*/
  t[1] && Qt();
  return {
    c() {
      e = R("div"), n && n.c(), C(e, "class", "container svelte-v3q4fo");
    },
    m(r, o) {
      J(r, e, o), n && n.m(e, null), t[3](e);
    },
    p(r, [o]) {
      /*isMounted*/
      r[1] ? n && (n.d(1), n = null) : n || (n = Qt(), n.c(), n.m(e, null));
    },
    i: z,
    o: z,
    d(r) {
      r && $(e), n && n.d(), t[3](null);
    }
  };
}
function Xo(t, e, n) {
  const r = $n();
  let o, a, i = !1, { value: u = {} } = e;
  bn(async () => {
    const l = await import("./editor.api-zaseAtYQ.js");
    Zt.config({ monaco: l.default }), o = await Zt.init(), n(1, i = !0);
    const v = o.editor.create(a, {
      theme: "vs-dark",
      language: "json",
      minimap: { enabled: !1 },
      padding: { top: 10 }
    }), c = o.editor.createModel(JSON.stringify(u, null, 2), "json");
    v.setModel(c), c.onDidChangeContent(() => {
      r("change", JSON.parse(c.getValue()));
    });
  }), ot(() => {
    o == null || o.editor.getModels().forEach((l) => l.dispose());
  });
  function s(l) {
    pt[l ? "unshift" : "push"](() => {
      a = l, n(0, a);
    });
  }
  return t.$$set = (l) => {
    "value" in l && n(2, u = l.value);
  }, [a, i, u, s];
}
class Jo extends pe {
  constructor(e) {
    super(), be(this, e, Xo, Ho, ue, { value: 2 }, $o);
  }
}
function Zo(t) {
  Ce(t, "svelte-bx0f0l", ".trigger.svelte-bx0f0l.svelte-bx0f0l{border-radius:6px;background-color:var(--pink);color:white;padding:0.5rem 1rem}.backdrop.svelte-bx0f0l.svelte-bx0f0l{position:fixed;top:0;left:0;z-index:9998;background:rgba(0, 0, 0, 0.5);width:100vw;height:100vh}.content.svelte-bx0f0l.svelte-bx0f0l{z-index:9999;position:fixed;top:50%;left:50%;transform:translate(-50%, -50%);background-color:#1e1e1e;border-radius:6px;width:80vw;max-width:800px;max-height:80vh;height:100%;min-height:0;overflow:auto;display:flex;flex-direction:column}.buttons.svelte-bx0f0l.svelte-bx0f0l{display:flex;justify-content:flex-end;gap:1rem 0.5rem;padding:1rem;background-color:#1e1e1e}.buttons.svelte-bx0f0l button.svelte-bx0f0l{border-radius:6px;padding:0.5rem 1rem;border:none;font-size:1rem;font-weight:500;cursor:pointer}.buttons.svelte-bx0f0l .cancel.svelte-bx0f0l{background-color:hsl(210, 40%, 96.1%);color:hsl(222.2, 47.4%, 11.2%)}.buttons.svelte-bx0f0l .save.svelte-bx0f0l{background-color:hsl(323, 72.8%, 59.2%);color:white}");
}
function en(t) {
  let e, n, r, o, a, i, u, s, l, v, c, h, b, x = [
    /*$overlay*/
    t[4],
    { class: "backdrop" }
  ], P = {};
  for (let A = 0; A < x.length; A += 1)
    P = Me(P, x[A]);
  o = new Jo({ props: { value: (
    /*value*/
    t[0]
  ) } }), o.$on(
    "change",
    /*change_handler*/
    t[12]
  );
  let w = [
    /*$content*/
    t[5],
    { class: "content" }
  ], N = {};
  for (let A = 0; A < w.length; A += 1)
    N = Me(N, w[A]);
  return {
    c() {
      e = R("div"), n = Y(), r = R("div"), Ee(o.$$.fragment), a = Y(), i = R("div"), u = R("button"), u.textContent = "Cancel", s = Y(), l = R("button"), l.textContent = "Save", _e(e, P), we(e, "svelte-bx0f0l"), C(u, "class", "cancel svelte-bx0f0l"), C(l, "class", "save svelte-bx0f0l"), C(i, "class", "buttons svelte-bx0f0l"), _e(r, N), we(r, "svelte-bx0f0l");
    },
    m(A, y) {
      J(A, e, y), J(A, n, y), J(A, r, y), de(o, r, null), T(r, a), T(r, i), T(i, u), T(i, s), T(i, l), c = !0, h || (b = [
        Ae(
          /*close*/
          t[10].action(u)
        ),
        Ae(
          /*close*/
          t[10].action(l)
        ),
        le(
          l,
          "click",
          /*click_handler*/
          t[13]
        ),
        Ae(
          /*content*/
          t[9].action(r)
        )
      ], h = !0);
    },
    p(A, y) {
      _e(e, P = gt(x, [y & /*$overlay*/
      16 && /*$overlay*/
      A[4], { class: "backdrop" }])), we(e, "svelte-bx0f0l");
      const F = {};
      y & /*value*/
      1 && (F.value = /*value*/
      A[0]), o.$set(F), _e(r, N = gt(w, [y & /*$content*/
      32 && /*$content*/
      A[5], { class: "content" }])), we(r, "svelte-bx0f0l");
    },
    i(A) {
      c || (G(o.$$.fragment, A), ie(() => {
        c && (v || (v = Dt(r, Mt, { duration: 150, start: 0.96 }, !0)), v.run(1));
      }), c = !0);
    },
    o(A) {
      X(o.$$.fragment, A), v || (v = Dt(r, Mt, { duration: 150, start: 0.96 }, !1)), v.run(0), c = !1;
    },
    d(A) {
      A && $(e), A && $(n), A && $(r), ve(o), A && v && v.end(), h = !1, ee(b);
    }
  };
}
function Qo(t) {
  let e, n, r, o, a, i, u, s, l = [
    /*$trigger*/
    t[2],
    { class: "trigger" }
  ], v = {};
  for (let h = 0; h < l.length; h += 1)
    v = Me(v, l[h]);
  let c = (
    /*$open*/
    t[3] && en(t)
  );
  return {
    c() {
      e = R("div"), n = R("button"), r = re("JSON Editor"), o = Y(), a = R("div"), c && c.c(), _e(n, v), we(n, "svelte-bx0f0l");
    },
    m(h, b) {
      J(h, e, b), T(e, n), T(n, r), n.autofocus && n.focus(), T(e, o), T(e, a), c && c.m(a, null), i = !0, u || (s = [
        Ae(
          /*trigger*/
          t[6].action(n)
        ),
        Ae(
          /*portal*/
          t[7].call(null, a)
        )
      ], u = !0);
    },
    p(h, [b]) {
      _e(n, v = gt(l, [b & /*$trigger*/
      4 && /*$trigger*/
      h[2], { class: "trigger" }])), we(n, "svelte-bx0f0l"), /*$open*/
      h[3] ? c ? (c.p(h, b), b & /*$open*/
      8 && G(c, 1)) : (c = en(h), c.c(), G(c, 1), c.m(a, null)) : c && (Ne(), X(c, 1, 1, () => {
        c = null;
      }), Fe());
    },
    i(h) {
      i || (G(c), i = !0);
    },
    o(h) {
      X(c), i = !1;
    },
    d(h) {
      h && $(e), c && c.d(), u = !1, ee(s);
    }
  };
}
function ei(t, e, n) {
  let r, o, a, i, { onChange: u = (y) => {
  } } = e, { value: s = {} } = e;
  const { trigger: l, portal: v, overlay: c, content: h, title: b, description: x, close: P, open: w } = ao();
  Ke(t, l, (y) => n(2, r = y)), Ke(t, c, (y) => n(4, a = y)), Ke(t, h, (y) => n(5, i = y)), Ke(t, w, (y) => n(3, o = y));
  const N = (y) => {
    n(0, s = y.detail);
  }, A = () => {
    u(s);
  };
  return t.$$set = (y) => {
    "onChange" in y && n(1, u = y.onChange), "value" in y && n(0, s = y.value);
  }, [
    s,
    u,
    r,
    o,
    a,
    i,
    l,
    v,
    c,
    h,
    P,
    w,
    N,
    A
  ];
}
class ti extends pe {
  constructor(e) {
    super(), be(this, e, ei, Qo, ue, { onChange: 1, value: 0 }, Zo);
  }
}
const yt = "abbyy-devtools";
function ni() {
  return {
    hasStoredValue: !!localStorage.getItem(yt),
    showDevtools: localStorage.getItem(yt) === "true"
  };
}
function bt(t) {
  localStorage.setItem(yt, JSON.stringify(t));
}
function ri(t) {
  Ce(t, "svelte-4f4m1x", '#abby-devtools-collapsed.svelte-4f4m1x.svelte-4f4m1x{--pink:rgb(249, 168, 212);bottom:var(--bottom);right:var(--right);left:var(--left);top:var(--top);z-index:9999;position:fixed;color:var(--pink);font-weight:bold;font-size:20px;background:#121929;font-family:ui-monospace, "Cascadia Code", "Source Code Pro", Menlo, Consolas, "DejaVu Sans Mono", monospace;width:50px;height:50px;border-radius:12px;border:2px solid var(--pink);display:flex;align-items:center;justify-content:center;box-shadow:0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1)}#abby-devtools.svelte-4f4m1x.svelte-4f4m1x{--pink:rgb(249, 168, 212);font-family:ui-monospace, "Cascadia Code", "Source Code Pro", Menlo, Consolas, "DejaVu Sans Mono", monospace;position:fixed;bottom:var(--bottom);right:var(--right);left:var(--left);top:var(--top);background:#121929;padding-inline:10px;padding-top:10px;z-index:9999;border-radius:6px;border:2px solid var(--pink);font-size:14px;color:hsl(213, 31%, 91%);min-width:300px;display:flex;flex-direction:column;max-height:calc(100vh - 3rem)}#abby-devtools.svelte-4f4m1x .logo.svelte-4f4m1x{font-family:"Martian Mono", inherit}#abby-devtools.svelte-4f4m1x hr.svelte-4f4m1x{margin:1rem 0;border-color:rgba(255, 255, 255, 0.4);border-bottom:0}#abby-devtools.svelte-4f4m1x small.svelte-4f4m1x{display:block;margin-top:10px;font-size:0.8rem}#abby-devtools.svelte-4f4m1x .header.svelte-4f4m1x{display:flex;align-items:center;justify-content:space-between}#abby-devtools.svelte-4f4m1x .header button.svelte-4f4m1x{all:unset;display:contents;cursor:pointer}#abby-devtools.svelte-4f4m1x .content.svelte-4f4m1x{margin-top:-1rem;padding-top:1rem;padding-bottom:calc(1rem - 10px);overflow-y:auto}#abby-devtools.svelte-4f4m1x .content.svelte-4f4m1x::-webkit-scrollbar{width:10px}#abby-devtools.svelte-4f4m1x .content.svelte-4f4m1x::-webkit-scrollbar-track{background-color:transparent}#abby-devtools.svelte-4f4m1x .content.svelte-4f4m1x::-webkit-scrollbar-thumb{background-color:rgba(255, 255, 255, 0.4);border:6px solid transparent;border-right-width:0px;background-clip:content-box}#abby-devtools.svelte-4f4m1x .content.svelte-4f4m1x::-webkit-scrollbar-thumb:hover{background-color:rgba(255, 255, 255, 0.6)}#abby-devtools.svelte-4f4m1x h1.svelte-4f4m1x,#abby-devtools.svelte-4f4m1x h2.svelte-4f4m1x{all:unset;color:var(--pink)}#abby-devtools.svelte-4f4m1x h1.svelte-4f4m1x{font-size:1.5rem;font-weight:bold}#abby-devtools.svelte-4f4m1x h2.svelte-4f4m1x{font-size:1.1rem;font-weight:600}');
}
function tn(t, e, n) {
  const r = t.slice();
  return r[16] = e[n][0], r[17] = e[n][1].selectedVariant, r[18] = e[n][1].variants, r;
}
function nn(t, e, n) {
  const r = t.slice();
  return r[21] = e[n][0], r[22] = e[n][1], r;
}
function rn(t, e, n) {
  const r = t.slice();
  return r[25] = e[n][0], r[26] = e[n][1], r;
}
function oi(t) {
  let e, n, r, o, a, i;
  return {
    c() {
      e = R("button"), e.textContent = "Ab", C(e, "class", "logo svelte-4f4m1x"), C(e, "id", "abby-devtools-collapsed"), W(
        e,
        "--right",
        /*position*/
        t[0] === "top-right" || /*position*/
        t[0] === "bottom-right" ? "1rem" : "auto"
      ), W(
        e,
        "--bottom",
        /*position*/
        t[0] === "bottom-left" || /*position*/
        t[0] === "bottom-right" ? "1rem" : "auto"
      ), W(
        e,
        "--left",
        /*position*/
        t[0] === "top-left" || /*position*/
        t[0] === "bottom-left" ? "1rem" : "auto"
      ), W(
        e,
        "--top",
        /*position*/
        t[0] === "top-left" || /*position*/
        t[0] === "top-right" ? "1rem" : "auto"
      );
    },
    m(u, s) {
      J(u, e, s), o = !0, a || (i = le(
        e,
        "click",
        /*onToggleVisibility*/
        t[3]
      ), a = !0);
    },
    p(u, s) {
      t = u, s & /*position*/
      1 && W(
        e,
        "--right",
        /*position*/
        t[0] === "top-right" || /*position*/
        t[0] === "bottom-right" ? "1rem" : "auto"
      ), s & /*position*/
      1 && W(
        e,
        "--bottom",
        /*position*/
        t[0] === "bottom-left" || /*position*/
        t[0] === "bottom-right" ? "1rem" : "auto"
      ), s & /*position*/
      1 && W(
        e,
        "--left",
        /*position*/
        t[0] === "top-left" || /*position*/
        t[0] === "bottom-left" ? "1rem" : "auto"
      ), s & /*position*/
      1 && W(
        e,
        "--top",
        /*position*/
        t[0] === "top-left" || /*position*/
        t[0] === "top-right" ? "1rem" : "auto"
      );
    },
    i(u) {
      o || (ie(() => {
        o && (r && r.end(1), n = mn(
          e,
          /*send*/
          t[7],
          { key: rt }
        ), n.start());
      }), o = !0);
    },
    o(u) {
      n && n.invalidate(), r = yn(
        e,
        /*receive*/
        t[8],
        { key: rt }
      ), o = !1;
    },
    d(u) {
      u && $(e), u && r && r.end(), a = !1, i();
    }
  };
}
function ii(t) {
  let e, n, r, o, a, i, u, s, l, v, c = (
    /*abby*/
    t[1].getConfig().currentEnvironment + ""
  ), h, b, x, P, w, N, A, y, F, Q, U, d, g, S, f, p, k, M, L, B, V, Z;
  i = new nr({});
  let te = Object.entries(
    /*flags*/
    t[4]
  ), K = [];
  for (let m = 0; m < te.length; m += 1)
    K[m] = on(rn(t, te, m));
  const he = (m) => X(K[m], 1, 1, () => {
    K[m] = null;
  });
  let j = Object.entries(
    /*remoteConfig*/
    t[6]
  ), O = [];
  for (let m = 0; m < j.length; m += 1)
    O[m] = an(nn(t, j, m));
  const q = (m) => X(O[m], 1, 1, () => {
    O[m] = null;
  });
  let I = Object.entries(
    /*tests*/
    t[5]
  ), D = [];
  for (let m = 0; m < I.length; m += 1)
    D[m] = ln(tn(t, I, m));
  const ne = (m) => X(D[m], 1, 1, () => {
    D[m] = null;
  });
  return {
    c() {
      e = R("div"), n = R("div"), r = R("h1"), r.textContent = "Abby Devtools", o = Y(), a = R("button"), Ee(i.$$.fragment), u = Y(), s = R("small"), l = re("Env: "), v = R("span"), h = re(c), b = Y(), x = R("hr"), P = Y(), w = R("div"), N = R("h2"), N.textContent = "Flags:", A = Y();
      for (let m = 0; m < K.length; m += 1)
        K[m].c();
      y = Y(), F = R("hr"), Q = Y(), U = R("h2"), U.textContent = "Remote Config:", d = Y();
      for (let m = 0; m < O.length; m += 1)
        O[m].c();
      g = Y(), S = R("hr"), f = Y(), p = R("h2"), p.textContent = "A/B Tests:", k = Y();
      for (let m = 0; m < D.length; m += 1)
        D[m].c();
      C(r, "class", "logo svelte-4f4m1x"), C(a, "class", "svelte-4f4m1x"), C(n, "class", "header svelte-4f4m1x"), W(v, "color", "var(--pink)"), W(v, "font-weight", "medium"), C(s, "class", "svelte-4f4m1x"), C(x, "class", "svelte-4f4m1x"), C(N, "class", "svelte-4f4m1x"), C(F, "class", "svelte-4f4m1x"), C(U, "class", "svelte-4f4m1x"), C(S, "class", "svelte-4f4m1x"), C(p, "class", "svelte-4f4m1x"), C(w, "class", "content svelte-4f4m1x"), C(e, "id", "abby-devtools"), C(e, "class", "svelte-4f4m1x"), W(
        e,
        "--right",
        /*position*/
        t[0] === "top-right" || /*position*/
        t[0] === "bottom-right" ? "1rem" : "auto"
      ), W(
        e,
        "--bottom",
        /*position*/
        t[0] === "bottom-left" || /*position*/
        t[0] === "bottom-right" ? "1rem" : "auto"
      ), W(
        e,
        "--left",
        /*position*/
        t[0] === "top-left" || /*position*/
        t[0] === "bottom-left" ? "1rem" : "auto"
      ), W(
        e,
        "--top",
        /*position*/
        t[0] === "top-left" || /*position*/
        t[0] === "top-right" ? "1rem" : "auto"
      );
    },
    m(m, E) {
      J(m, e, E), T(e, n), T(n, r), T(n, o), T(n, a), de(i, a, null), T(e, u), T(e, s), T(s, l), T(s, v), T(v, h), T(e, b), T(e, x), T(e, P), T(e, w), T(w, N), T(w, A);
      for (let _ = 0; _ < K.length; _ += 1)
        K[_] && K[_].m(w, null);
      T(w, y), T(w, F), T(w, Q), T(w, U), T(w, d);
      for (let _ = 0; _ < O.length; _ += 1)
        O[_] && O[_].m(w, null);
      T(w, g), T(w, S), T(w, f), T(w, p), T(w, k);
      for (let _ = 0; _ < D.length; _ += 1)
        D[_] && D[_].m(w, null);
      B = !0, V || (Z = le(
        a,
        "click",
        /*onToggleVisibility*/
        t[3]
      ), V = !0);
    },
    p(m, E) {
      if (t = m, (!B || E & /*abby*/
      2) && c !== (c = /*abby*/
      t[1].getConfig().currentEnvironment + "") && Oe(h, c), E & /*Object, flags, window, abby*/
      18) {
        te = Object.entries(
          /*flags*/
          t[4]
        );
        let _;
        for (_ = 0; _ < te.length; _ += 1) {
          const H = rn(t, te, _);
          K[_] ? (K[_].p(H, E), G(K[_], 1)) : (K[_] = on(H), K[_].c(), G(K[_], 1), K[_].m(w, y));
        }
        for (Ne(), _ = te.length; _ < K.length; _ += 1)
          he(_);
        Fe();
      }
      if (E & /*Object, remoteConfig, window, abby*/
      66) {
        j = Object.entries(
          /*remoteConfig*/
          t[6]
        );
        let _;
        for (_ = 0; _ < j.length; _ += 1) {
          const H = nn(t, j, _);
          O[_] ? (O[_].p(H, E), G(O[_], 1)) : (O[_] = an(H), O[_].c(), G(O[_], 1), O[_].m(w, g));
        }
        for (Ne(), _ = j.length; _ < O.length; _ += 1)
          q(_);
        Fe();
      }
      if (E & /*Object, tests, window, abby*/
      34) {
        I = Object.entries(
          /*tests*/
          t[5]
        );
        let _;
        for (_ = 0; _ < I.length; _ += 1) {
          const H = tn(t, I, _);
          D[_] ? (D[_].p(H, E), G(D[_], 1)) : (D[_] = ln(H), D[_].c(), G(D[_], 1), D[_].m(w, null));
        }
        for (Ne(), _ = I.length; _ < D.length; _ += 1)
          ne(_);
        Fe();
      }
      E & /*position*/
      1 && W(
        e,
        "--right",
        /*position*/
        t[0] === "top-right" || /*position*/
        t[0] === "bottom-right" ? "1rem" : "auto"
      ), E & /*position*/
      1 && W(
        e,
        "--bottom",
        /*position*/
        t[0] === "bottom-left" || /*position*/
        t[0] === "bottom-right" ? "1rem" : "auto"
      ), E & /*position*/
      1 && W(
        e,
        "--left",
        /*position*/
        t[0] === "top-left" || /*position*/
        t[0] === "bottom-left" ? "1rem" : "auto"
      ), E & /*position*/
      1 && W(
        e,
        "--top",
        /*position*/
        t[0] === "top-left" || /*position*/
        t[0] === "top-right" ? "1rem" : "auto"
      );
    },
    i(m) {
      if (!B) {
        G(i.$$.fragment, m);
        for (let E = 0; E < te.length; E += 1)
          G(K[E]);
        for (let E = 0; E < j.length; E += 1)
          G(O[E]);
        for (let E = 0; E < I.length; E += 1)
          G(D[E]);
        ie(() => {
          B && (L && L.end(1), M = mn(
            e,
            /*send*/
            t[7],
            { key: rt }
          ), M.start());
        }), B = !0;
      }
    },
    o(m) {
      X(i.$$.fragment, m), K = K.filter(Boolean);
      for (let E = 0; E < K.length; E += 1)
        X(K[E]);
      O = O.filter(Boolean);
      for (let E = 0; E < O.length; E += 1)
        X(O[E]);
      D = D.filter(Boolean);
      for (let E = 0; E < D.length; E += 1)
        X(D[E]);
      M && M.invalidate(), L = yn(
        e,
        /*receive*/
        t[8],
        { key: rt }
      ), B = !1;
    },
    d(m) {
      m && $(e), ve(i), Ve(K, m), Ve(O, m), Ve(D, m), m && L && L.end(), V = !1, Z();
    }
  };
}
function on(t) {
  let e, n;
  function r(...o) {
    return (
      /*func*/
      t[11](
        /*flagName*/
        t[25],
        ...o
      )
    );
  }
  return e = new cr({
    props: {
      id: (
        /*flagName*/
        t[25]
      ),
      label: (
        /*flagName*/
        t[25]
      ),
      checked: (
        /*flagValue*/
        t[26]
      ),
      onChange: r
    }
  }), {
    c() {
      Ee(e.$$.fragment);
    },
    m(o, a) {
      de(e, o, a), n = !0;
    },
    p(o, a) {
      t = o;
      const i = {};
      a & /*abby*/
      2 && (i.onChange = r), e.$set(i);
    },
    i(o) {
      n || (G(e.$$.fragment, o), n = !0);
    },
    o(o) {
      X(e.$$.fragment, o), n = !1;
    },
    d(o) {
      ve(e, o);
    }
  };
}
function ai(t) {
  let e, n, r = (
    /*remoteConfigName*/
    t[21] + ""
  ), o, a, i, u;
  function s(...l) {
    return (
      /*func_2*/
      t[13](
        /*remoteConfigName*/
        t[21],
        ...l
      )
    );
  }
  return i = new ti({
    props: {
      value: (
        /*remoteConfigValue*/
        t[22]
      ),
      onChange: s
    }
  }), {
    c() {
      e = R("div"), n = R("p"), o = re(r), a = Y(), Ee(i.$$.fragment), W(n, "margin-bottom", "5px"), W(e, "display", "flex"), W(e, "flex-direction", "column"), W(e, "margin", "10px 0");
    },
    m(l, v) {
      J(l, e, v), T(e, n), T(n, o), T(e, a), de(i, e, null), u = !0;
    },
    p(l, v) {
      t = l;
      const c = {};
      v & /*abby*/
      2 && (c.onChange = s), i.$set(c);
    },
    i(l) {
      u || (G(i.$$.fragment, l), u = !0);
    },
    o(l) {
      X(i.$$.fragment, l), u = !1;
    },
    d(l) {
      l && $(e), ve(i);
    }
  };
}
function li(t) {
  let e, n;
  function r(...o) {
    return (
      /*func_1*/
      t[12](
        /*remoteConfigName*/
        t[21],
        ...o
      )
    );
  }
  return e = new gr({
    props: {
      id: (
        /*remoteConfigName*/
        t[21]
      ),
      label: (
        /*remoteConfigName*/
        t[21]
      ),
      type: typeof /*remoteConfigValue*/
      t[22] == "string" ? "text" : "number",
      value: (
        /*remoteConfigValue*/
        t[22]
      ),
      onChange: r
    }
  }), {
    c() {
      Ee(e.$$.fragment);
    },
    m(o, a) {
      de(e, o, a), n = !0;
    },
    p(o, a) {
      t = o;
      const i = {};
      a & /*abby*/
      2 && (i.onChange = r), e.$set(i);
    },
    i(o) {
      n || (G(e.$$.fragment, o), n = !0);
    },
    o(o) {
      X(e.$$.fragment, o), n = !1;
    },
    d(o) {
      ve(e, o);
    }
  };
}
function an(t) {
  let e, n, r, o;
  const a = [li, ai], i = [];
  function u(s, l) {
    return typeof /*remoteConfigValue*/
    s[22] == "string" || typeof /*remoteConfigValue*/
    s[22] == "number" ? 0 : typeof /*remoteConfigValue*/
    s[22] == "object" ? 1 : -1;
  }
  return ~(e = u(t)) && (n = i[e] = a[e](t)), {
    c() {
      n && n.c(), r = dn();
    },
    m(s, l) {
      ~e && i[e].m(s, l), J(s, r, l), o = !0;
    },
    p(s, l) {
      n && n.p(s, l);
    },
    i(s) {
      o || (G(n), o = !0);
    },
    o(s) {
      X(n), o = !1;
    },
    d(s) {
      ~e && i[e].d(s), s && $(r);
    }
  };
}
function ln(t) {
  let e, n;
  function r(...o) {
    return (
      /*func_4*/
      t[14](
        /*testName*/
        t[16],
        ...o
      )
    );
  }
  return e = new ar({
    props: {
      label: (
        /*testName*/
        t[16]
      ),
      value: (
        /*selectedVariant*/
        t[17]
      ),
      options: (
        /*variants*/
        t[18].map(ui)
      ),
      onChange: r
    }
  }), {
    c() {
      Ee(e.$$.fragment);
    },
    m(o, a) {
      de(e, o, a), n = !0;
    },
    p(o, a) {
      t = o;
      const i = {};
      a & /*abby*/
      2 && (i.onChange = r), e.$set(i);
    },
    i(o) {
      n || (G(e.$$.fragment, o), n = !0);
    },
    o(o) {
      X(e.$$.fragment, o), n = !1;
    },
    d(o) {
      ve(e, o);
    }
  };
}
function si(t) {
  let e, n, r, o;
  const a = [ii, oi], i = [];
  function u(s, l) {
    return (
      /*show*/
      s[2] ? 0 : 1
    );
  }
  return e = u(t), n = i[e] = a[e](t), {
    c() {
      n.c(), r = dn();
    },
    m(s, l) {
      i[e].m(s, l), J(s, r, l), o = !0;
    },
    p(s, [l]) {
      let v = e;
      e = u(s), e === v ? i[e].p(s, l) : (Ne(), X(i[v], 1, 1, () => {
        i[v] = null;
      }), Fe(), n = i[e], n ? n.p(s, l) : (n = i[e] = a[e](s), n.c()), G(n, 1), n.m(r.parentNode, r));
    },
    i(s) {
      o || (G(n), o = !0);
    },
    o(s) {
      X(n), o = !1;
    },
    d(s) {
      i[e].d(s), s && $(r);
    }
  };
}
let rt = "devtools";
const ui = (t) => ({ label: t, value: t });
function ci(t, e, n) {
  let { position: r = "bottom-right" } = e, { defaultShow: o = !1 } = e, { shortcut: a = ["command+.", "ctrl+."] } = e, { abby: i } = e, u = !1;
  const s = () => {
    n(2, u = !u), bt(u);
  }, l = (y) => {
    y.data === "abby:toggle-devtools" && s(), y.data === "abby:close-devtools" && (n(2, u = !1), bt(u)), y.data === "abby:open-devtools" && (n(2, u = !0), bt(u));
  };
  bn(async () => {
    const { hasStoredValue: y, showDevtools: F } = ni();
    y ? n(2, u = F) : n(2, u = o), Nt.bind(a, s), window.addEventListener("message", l);
  }), ot(() => {
    Nt.unbind(a), window.removeEventListener("message", l);
  });
  const { flags: v, tests: c, remoteConfig: h } = (i == null ? void 0 : i.getProjectData()) ?? {}, [b, x] = vr({ duration: 200, easing: fr }), P = (y, F) => {
    window.postMessage(
      {
        type: "abby:update-flag",
        flagName: y,
        newValue: F
      },
      "*"
    ), i.updateFlag(y, F);
  }, w = (y, F) => {
    window.postMessage(
      {
        type: "abby:update-flag",
        remoteConfigName: y,
        newValue: F
      },
      "*"
    ), i.updateRemoteConfig(y, F);
  }, N = (y, F) => {
    window.postMessage(
      {
        type: "abby:update-flag",
        remoteConfigName: y,
        newValue: F
      },
      "*"
    ), i.updateRemoteConfig(y, F);
  }, A = (y, F) => {
    window.postMessage(
      {
        type: "abby:select-variant",
        testName: y,
        newValue: F
      },
      "*"
    ), i.updateLocalVariant(y, F);
  };
  return t.$$set = (y) => {
    "position" in y && n(0, r = y.position), "defaultShow" in y && n(9, o = y.defaultShow), "shortcut" in y && n(10, a = y.shortcut), "abby" in y && n(1, i = y.abby);
  }, [
    r,
    i,
    u,
    s,
    v,
    c,
    h,
    b,
    x,
    o,
    a,
    P,
    w,
    N,
    A
  ];
}
class fi extends pe {
  constructor(e) {
    super(), be(
      this,
      e,
      ci,
      si,
      ue,
      {
        position: 0,
        defaultShow: 9,
        shortcut: 10,
        abby: 1
      },
      ri
    );
  }
}
class di {
  create(e) {
    const n = new fi({
      target: document.body,
      props: e
    });
    return () => {
      n == null || n.$destroy();
    };
  }
}
const vi = new di();
export {
  di as DevtoolsFactory,
  vi as default
};
